if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
if (typeof window.Shopify.theme == 'undefined') {
  window.Shopify.theme = {};
}
if (typeof window.Shopify.theme.helpers == 'undefined') {
  window.Shopify.theme.helpers = {};
}
if (typeof window.theme.wishlist == 'undefined') {
  window.theme.wishlist = {};
}

// The below script is used to help defend against malicious sites that
// clone Meshki and host on a third-party domain. Under normal circumstances
// (where the user is on a legitimate Meshki domain), this code will do nothing.

const validDomains = [
  'meshki.co.uk',
  'www.meshki.co.uk',
  'www.meshki.com.au',
  'www.meshki.us',
  'meshki-uk.myshopify.com',
  'meshki-us.myshopify.com',
  'meshki-clothing.myshopify.com',
  'meshki-development.myshopify.com',
  'meshki-development-us.myshopify.com',
  'meshki-development-uk.myshopify.com',
  'shopifypreview.com'
];
if (!validDomains.some(item => window.location.hostname.includes(item))) {
  window.location = 'https://www.meshki.com.au';
}

//store the current page url without query params in session storage
sessionStorage.setItem('thirdLastVisitedPage', sessionStorage.getItem('secondLastVisitedPage'));
sessionStorage.setItem('secondLastVisitedPage', sessionStorage.getItem('lastVisitedPage'));
sessionStorage.setItem('lastVisitedPage', window.location.href);

const html = (strings, ...values) => String.raw({ raw: strings }, ...values);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      ".mega-menu__button, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] .mega-menu__button').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('.mega-menu').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// BEGIN CUSTOM: data-hover-toggle
(() => {
  const openMenu = (details, searchInput) => {
    details.setAttribute('open', '');
    details.querySelector('.mega-menu__button').setAttribute('aria-expanded', true);
    document.body.classList.add('is-header-menu-open');
    searchInput?.focus();
  };

  const closeMenu = (details) => {
    details.removeAttribute('open');
    details.querySelector('.mega-menu__button').setAttribute('aria-expanded', false);
    document.body.classList.remove('is-header-menu-open');
    document.removeEventListener('click', closeOnClick);
  };

  const closeOnClick = (event) => {
    const details = document.querySelector('.mega-menu[open]');
    if (!details) return;

    const openMega = details.querySelector('.mega-menu__content');

    if (!openMega.contains(event.target) && openMega !== event.target) {
      closeMenu(details);
      document.body.classList.remove('is-header-menu-open');
      document.removeEventListener('click', closeOnClick);
    }
  };

  document.querySelectorAll('.header .list-menu li > a.header__menu-item').forEach((simpleLink) => {
    simpleLink.addEventListener('focusin', (event) => {
      // close any open menus
      const openMenus = document.querySelectorAll('.mega-menu[open]');
      openMenus.forEach(closeMenu);
    });
    simpleLink.addEventListener('mouseenter', (event) => {
      // close any open menus
      const openMenus = document.querySelectorAll('.mega-menu[open]');
      openMenus.forEach(closeMenu);
    });
  });

  document.querySelectorAll('[id^="Details-"] .mega-menu__content').forEach((menu) => {
    const details = menu.closest('.mega-menu');
    const hoverElement = details.querySelector('.mega-menu__button[data-hover-toggle]');
    const pauseMs = 150;

    if (!hoverElement) return;

    menu.addEventListener('focusin', (event) => {
      const isOpen = details.hasAttribute('open');

      if (isOpen) return;

      // close any open menus
      const openMenus = document.querySelectorAll('.mega-menu[open]');
      openMenus.forEach(closeMenu);

      setTimeout(() => {
        openMenu(details);
      }, pauseMs);

      // close on clicking outside
      document.removeEventListener('click', closeOnClick);
      document.addEventListener('click', closeOnClick);
    });
  });

  document.querySelectorAll('[id^="Details-"] .mega-menu__button:not([data-hover-toggle])').forEach((summary) => {
    const details = summary.closest('.mega-menu');
    const menu = details.querySelector('.mega-menu__content');
    const searchInput = details.querySelector('.search__input');
    const pauseMs = 150;

    summary.addEventListener('click', (event) => {
      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        closeMenu(details);
        document.removeEventListener('click', closeOnClick);
        return;
      }

      // close any open menus
      const openMenus = document.querySelectorAll('.mega-menu[open]');
      openMenus.forEach(closeMenu);

      setTimeout(() => {
        openMenu(details, searchInput);
      }, pauseMs);

      // close on clicking outside
      document.removeEventListener('click', closeOnClick);
      document.addEventListener('click', closeOnClick);
    });
  });

  document.querySelectorAll('[id^="Details-"] .mega-menu__button[data-hover-toggle]').forEach((summary) => {
    const details = summary.closest('.mega-menu');
    const menu = details.querySelector('.mega-menu__content');
    const pauseMs = 150;

    summary.addEventListener('focusin', (event) => {
      // close any open menus
      const openMenus = document.querySelectorAll('.mega-menu[open]');
      openMenus.forEach(closeMenu);

      setTimeout(() => {
        openMenu(details);
      }, pauseMs);

      // close on clicking outside
      document.removeEventListener('click', closeOnClick);
      document.addEventListener('click', closeOnClick);
    });

    summary.addEventListener('mouseenter', (event) => {
      // close any open menus
      const openMenus = document.querySelectorAll('.mega-menu[open]');
      openMenus.forEach(closeMenu);

      if (openMenus.length) {
        // if a menu is already open, immediately open the new one
        openMenu(details);
      } else {
        // if no menus open, pause and check for continued hover before opening
        // reduces mega menus popping open from random mouse movement
        setTimeout(() => {
          if (summary.matches(':hover')) {
            openMenu(details);
          }
        }, pauseMs);
      }

      // close on clicking outside
      document.removeEventListener('click', closeOnClick);
      document.addEventListener('click', closeOnClick);
    });

    menu.addEventListener('mouseleave', (event) => {
      closeMenu(details);
      menu.setAttribute('aria-expanded', false);
    });
  });
})();
// END CUSTOM: data-hover-toggle

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video:not(.do-not-pause)').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

//Quick check if an element is in viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

//Scroll element to viewport
function checkAndScroll(element) {
  if (!isInViewport(element)) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  if (!this.countryEl || !this.provinceEl || !this.provinceContainer) return;
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    // BEGIN CUSTOM
    this.header = this.closest('.header-wrapper');

    // Delay addition of header background transitions to avoid a transition on page load whilst logic is applied
    setTimeout(() => {
      this.header?.classList.add('transitions');
      document.body.classList.add('transitions');
    }, 2000);
    // END CUSTOM
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button.drawer__close').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        document.body.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    document.body.classList.add('is-menu-drawer-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement?.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details:not(.has-active-selections)').forEach((details) => {
      details.removeAttribute('open');
    });
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
      document.body.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);

    // BEGIN CUSTOM
    this.header?.classList.remove('is-header-menu-open');
    document.body.classList.remove('is-menu-drawer-open');
    // END CUSTOM
  }

  onFocusOut() {
    setTimeout(() => {
      // if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
      // if (this.mainDetailsToggle.hasAttribute('open')) this.closeMenuDrawer(true);
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeMenuDrawer(event, detailsElement.querySelector('summary'));
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    document.body.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    for (const button of this.querySelectorAll('[id^="ModalClose-"], [data-close-modal]')) {
      button.addEventListener('click', this.hide.bind(this, false));
    }

    this.addEventListener('keyup', (event) => {
      if (this.dataset.dontAutoClose === undefined && event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          this.dataset.dontAutoClose === undefined &&
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model, [data-scroll-indicator]')
        ) {
          this.hide();
        }
      });
    } else {
      this.addEventListener('click', (event) => {
        if (this.dataset.dontAutoClose === undefined && event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    const autoClose = Boolean(this.dataset.dontAutoClose === undefined);

    if (autoClose) {
    }

    this.moveModal();
  }

  moveModal(opener) {
    if (this.moved || this.dataset.dontMoveMe !== undefined) return;

    this.moved = true;

    let moveTarget;
    if (this.dataset.moveMeTo !== undefined) {
      moveTarget = this.closest(this.dataset.moveMeTo);
    }

    if (moveTarget) {
      moveTarget.appendChild(this);
    } else {
      document.body.appendChild(this);
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');

    if (this.dataset.allowScrolling === undefined) {
      document.body.classList.add('overflow-hidden');
    }
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class AlertModalDialog extends ModalDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.textEl = this.querySelector('[data-error-msg]');
    window.Shopify.theme.helpers.alert = this.show.bind(this);
  }

  show(message) {
    if (!message || !this.textEl) {
      return;
    }
    this.textEl.textContent = message;
    super.show();
  }
}

customElements.define('alert-modal-dialog', AlertModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class DeferredVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.deferredSrcs = this.video.querySelectorAll('source[data-src]');
    if (!this.video || !this.deferredSrcs.length) return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.attachObserver.bind(this));
    } else {
      this.attachObserver();
    }
  }

  attachObserver() {
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((video) => {
          if (video.isIntersecting) {
            this.loadVideo(video.target);
            videoObserver.unobserve(video.target);
          }
        });
      });
      videoObserver.observe(this.video);
    } else {
      this.loadVideo.bind(this, this.video);
    }
  }

  loadVideo(video) {
    if (this.getAttribute('loaded')) {
      return;
    }
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
    }
    this.deferredSrcs.forEach((source) => {
      source.src = source.dataset.src;
    });
    video.load();
    this.setAttribute('loaded', true);
  }
}

customElements.define('deferred-video', DeferredVideo);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotButtons = this.querySelectorAll('button[name="dot"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));

    if (this.dotButtons.length) {
      Array.from(this.dotButtons).forEach((dot) => {
        dot.addEventListener('click', this.onDotClick.bind(this));
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.dotButtons.length) {
      Array.from(this.dotButtons).forEach((dot) => dot.classList?.remove('is-active'));
      Array.from(this.dotButtons)[this.currentPage - 1]?.classList?.add('is-active');
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  onDotClick(event) {
    event.preventDefault();
    const targetSlideIndex1 = parseInt(event.currentTarget.dataset.step) || 1;
    this.slideScrollPosition = (targetSlideIndex1 - 1) * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class CountdownBanner extends HTMLElement {
  constructor() {
    super();
    this.countdownUrl = this.getAttribute('data-countdown-url') || '#';
    this.messageBefore = this.getAttribute('data-countdown-message-before') || '';
    this.messageAfter = this.getAttribute('data-countdown-message-after') || '';
    this.countdownMinutes = parseInt(this.getAttribute('data-countdown-minutes'), 10) || 0;
    this.countdownHours = parseInt(this.getAttribute('data-countdown-hours'), 10) || 0;
    this.countdownDay = parseInt(this.getAttribute('data-countdown-day'), 10) || 1;
    this.countdownMonth = parseInt(this.getAttribute('data-countdown-month'), 10) || 1;
    this.countdownYear = parseInt(this.getAttribute('data-countdown-year'), 10) || 2024;

    // Build a time in the store's zone; JS handles AEST/AEDT automatically
    const end = new Date(
      Date.UTC(this.countdownYear, this.countdownMonth - 1, this.countdownDay, this.countdownHours, this.countdownMinutes)
    );

    // Convert that “local Sydney” time into the equivalent UTC instant
    const sydneyOffsetMinutes = -new Date(
      end.toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
    ).getTimezoneOffset();

    this.countDownDate = end.getTime() - sydneyOffsetMinutes * 60 * 1000;
  }

  connectedCallback() {
    console.log(this.innerHTML.trim() === '');
    if (this.innerHTML.trim() === '') {
      this.render();
    }
    this.startCountdown();
  }

  render() {
    this.innerHTML = `
      <div class="header__countdown-container">
        <a href="${this.countdownUrl}">
          <div>
            ${this.messageBefore}
            <span id="header__countdown">
              <b>--</b>d <b>--</b>h <b>--</b>m <b>--</b>s
            </span>
            ${this.messageAfter}
          </div>
        </a>
      </div>
    `;
  }

  startCountdown() {
    const countdownElement = this.querySelector('#header__countdown');
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = this.countDownDate - now;

      if (distance < 0) {
        clearInterval(interval);
        this.style.display = 'none';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownElement.innerHTML = `
        ${days > 0 ? `<b>${days}</b>d ` : ''}
        <b>${hours}</b>h <b>${minutes}</b>m <b>${seconds}</b>s
      `;
    }, 1000);
  }
}

customElements.define('countdown-banner', CountdownBanner);

class DraggableSliderComponent extends SliderComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    gsap.registerPlugin(Draggable);

    this.progressWrap = this.querySelector('.slider__progress-wrap');
    this.progressTrack = this.querySelector('.slider__progress-track');
    this.progressBar = this.querySelector('.slider__progress-bar');
    this.dragProxy = this.querySelector('.slider__drag-proxy');
    this.scrollableUl = this.querySelector('ul');
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.init();
    this.initEvents();
    this.checkScrollability();
    this.centerSliderItems();
  }

  init() {
    window.addEventListener('resize', debounce(this.resizeEvents.bind(this), 100));
    this.addEventListener('animationend', this.checkScrollability.bind(this));
    this.scrollableUl?.addEventListener('mousedown', this.startDraging.bind(this));
    this.scrollableUl?.addEventListener('mouseleave', this.endDraging.bind(this));
    this.scrollableUl?.addEventListener('mouseup', this.endDraging.bind(this));
    this.scrollableUl?.addEventListener('mousemove', this.drag.bind(this));
  }

  resizeEvents(){
    this.checkScrollability();
    this.centerSliderItems();
  }

  centerSliderItems() {
    if(this.classList.contains('center-slider-items')) {
      const isOverflowing = this.scrollableUl.scrollWidth > this.scrollableUl.clientWidth;

      if (isOverflowing) {
        this.scrollableUl.classList.remove('centered');
      } else {
        this.scrollableUl.classList.add('centered');
      }
    }
  }

  initEvents() {
    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.dragProxy) {
      const slider = this.slider;

      Draggable.create(this.dragProxy, {
        type: 'x',
        trigger: slider,
        onDrag() {
          slider.scrollLeft += this.startX - this.x;
        },
      });
    }
  }

  startDraging(e) {
    this.isDragging = true;
    this.startX = e.pageX - this.scrollableUl.offsetLeft;
    this.scrollLeft = this.scrollableUl.scrollLeft;
  }

  endDraging() {
    this.isDragging = false;
    this.scrollableUl.classList.remove('scrolling-active');
  }

  drag(e) {
    if (!this.isDragging) return;
    if (!this.scrollableUl.classList.contains('scrolling-active')) {
      this.scrollableUl.classList.add('scrolling-active');
    }
    e.preventDefault();

    const x = e.pageX - this.scrollableUl.offsetLeft;
    const walk = (x - this.startX) * 2;
    console.log(`walk= ${walk}`);
    this.scrollableUl.scrollLeft = this.scrollableUl.scrollLeft - walk;
  }

  update() {
    this.updateProgressBar();
  }

  updateProgressBar() {
    const progressTrackWidth = this.progressTrack.clientWidth;
    const progressBarWidth = this.progressBar.clientWidth;
    const maxBarX = progressTrackWidth - progressBarWidth;
    const scrollDecimal = this.slider.scrollLeft / (this.slider.scrollWidth - this.slider.clientWidth);

    this.progressBar.style.transform = `translateX(${scrollDecimal * maxBarX}px)`;
  }

  checkScrollability() {
    const scrollable = this.slider.scrollWidth > this.slider.clientWidth;

    // Just working with opacity to avoid any layout shift
    if (scrollable) {
      this.progressWrap.style.opacity = 1;
    } else {
      this.progressWrap.style.opacity = 0;
    }
  }
}

customElements.define('draggable-slider-component', DraggableSliderComponent);

class FindFitSlider extends DraggableSliderComponent {
  constructor() {
    super();
    this._suppressIoWhileProgrammaticScroll = false;
    this._isUserScrolling = false;
    this._scrollIdleTimer = null;
    this._pendingFitIdx = null;
    this._SCROLL_IDLE_MS = 150;
    this._currentFitIdx = 0;
    this._visibleByFit = new Map();
  }

  connectedCallback() {
    super.connectedCallback();

    // elements
    this.labelsWrap = this.querySelector('.find-fit-labels');
    this.labels = Array.from(this.querySelectorAll('.find-fit-link'));
    this.productsUl = this.querySelector('[id^="Slider-"]');
    this.firstSlides = Array.from(this.querySelectorAll('[data-fit-first="true"]'));
    this.allSlides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
    this.viewAllLinks = Array.from(this.querySelectorAll('.view-all-fit'));

    if (!this.slider || !this.labels.length || !this.firstSlides.length) return;

    // click → smooth scroll to the start of that fit
    this.labels.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const fitIdx = Number(btn.dataset.index || 0);
        const target = this.firstSlides.find(el => Number(el.dataset.fitIndex) === fitIdx);
        if (!target) return;

        // mark programmatic scroll; stage desired state; update label immediately if you like
        this._suppressIoWhileProgrammaticScroll = true;
        this._pendingFitIdx = fitIdx;
        this._currentFitIdx = fitIdx; // keep internal state aligned with the intent
        this._applyActiveFit(fitIdx);

        // do the scroll 
        this.setSlidePosition(target.offsetLeft);

        // clear suppression after a short while (or on 'scrollend' if you prefer)
        clearTimeout(this._progTimer);
        this._progTimer = setTimeout(() => {
          this._suppressIoWhileProgrammaticScroll = false;
        }, 1000);
      });
    });

    // Observe ALL slides (we need counts, not just the firsts)
    this._io = new IntersectionObserver(this.onIntersect.bind(this), {
      root: this.slider,         // observe within the slider viewport
      threshold: [0, 0.01, 0.5, 0.99]  // early + mid + almost full
    });
    this.allSlides.forEach(el => this._io.observe(el));

    // Scroll tracking (drag/touch/wheel)
    // this._boundOnScroll = this.onScroll.bind(this);
    // this.slider.addEventListener('scroll', this._boundOnScroll, { passive: true });

    // ['touchstart','pointerdown','wheel','mousedown'].forEach((evt) => {
    //   this.slider.addEventListener(evt, () => {
    //     this._isUserScrolling = true;
    //   }, { passive: true });
    // });
  }

  disconnectedCallback() {
    if (this._io) this._io.disconnect();
    if (this._boundOnScroll) this.slider?.removeEventListener('scroll', this._boundOnScroll);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({ left: position });
  }

  // onScroll() {
  //   this._isUserScrolling = true;
  //   if (this._scrollIdleTimer) clearTimeout(this._scrollIdleTimer);

  //   this._scrollIdleTimer = setTimeout(() => {
  //     this._isUserScrolling = false;

  //     // if we buffered something during scroll, re-evaluate *now*
  //     const next = this._chooseDominantFit();
  //     if (next != null) {
  //       // Apply only if rule says so (handled inside _maybeApplyDominantFit)
  //       this._maybeApplyDominantFit(next);
  //     }
  //   }, this._SCROLL_IDLE_MS);
  // }

  onIntersect(entries) {
    // build/maintain visible sets per fit
    for (const entry of entries) {
      const fitIdx = Number(entry.target.dataset.fitIndex);
      if (Number.isNaN(fitIdx)) continue;

      if (!this._visibleByFit.has(fitIdx)) {
        this._visibleByFit.set(fitIdx, new Set());
      }
      const set = this._visibleByFit.get(fitIdx);

      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        set.add(entry.target);
      } else {
        set.delete(entry.target);
      }
    }

    // Don’t update visuals while programmatic or user is actively scrolling;
    // but remember the latest dominant candidate.
    const dominant = this._chooseDominantFit();
    if (dominant == null) return;

    if (this._suppressIoWhileProgrammaticScroll || this._isUserScrolling) {
      this._pendingFitIdx = dominant;
      return;
    }

    this._maybeApplyDominantFit(dominant);
  }

  _chooseDominantFit() {
    // Count total visible slides and which fit has the most
    let total = 0;
    let maxFit = null;
    let maxCount = -1;

    // Calculate totals
    for (const [fitIdx, set] of this._visibleByFit.entries()) {
      const count = set.size;
      total += count;
      if (count > maxCount) {
        maxCount = count;
        maxFit = fitIdx;
      } else if (count === maxCount && maxCount > 0) {
        // If tie between nonzero counts, prefer the *new* one if different from current.
        // We'll finalize tie-break below with share calc.
      }
    }

    if (total === 0 || maxFit == null) return null;

    // compute share of the top fit (avoid division by zero)
    const share = maxCount / Math.max(1, total);

    return { maxFit, share, total, maxCount };
  }

  _maybeApplyDominantFit({ maxFit, share }) {
    const isDifferent = maxFit !== this._currentFitIdx;

    // Rule:
    // - update if the dominant fit has > 50% of visible slides
    // - or exactly 50% but it's a different fit (tie favors the *new* one)
    if (share > 0.5 || (share === 0.5 && isDifferent)) {
      this._currentFitIdx = maxFit;
      this._applyActiveFit(maxFit);
      this._pendingFitIdx = null;
    }
  }

  _applyActiveFit(fitIdx) {
    this.setActiveFit(fitIdx);
    this.updateProgressVisual(fitIdx);
  }

  setActiveFit(fitIdx) {
    this.labels.forEach(l => {
      if(Number(l.dataset.index) === Number(fitIdx)){
        l.classList.add('active');
      }
      else {
        l.classList.remove('active')
      }
    });
    this.viewAllLinks.forEach(l => {
      if(Number(l.dataset.index) === Number(fitIdx)){
        l.classList.add('active');
      }
      else
      {l.classList.remove('active');}
    });
    // const active = this.labels.find(l => Number(l.dataset.index) === Number(fitIdx));
    // if (active) active.classList.add('active');
    
    // const activeLink = this.viewAllLinks.find(l => Number(l.dataset.index) === Number(fitIdx));
    // if (activeLink) activeLink.classList.add('active');
  }

  updateProgressVisual(fitIdx) {
    const prog = this.querySelector('.find-fit-progress .progressed-bar');
    if (!prog) return;
    const count = this.labels.length;
    let pct = count > 1 ? ((((fitIdx + 1) * 2) - 1) / (count * 2)) * 100 : 0;
    if (fitIdx === 0) pct = 0;
    if (fitIdx === count - 1) pct = 100;
    prog.style.width = `${pct}%`;
  }
}

customElements.define('find-fit-slider', FindFitSlider);



class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.colorSwatches = this.querySelectorAll('[data-swatches');
    this.colorSwatches.forEach((swatch) => this.initColorSwatches(swatch));
  }

  initColorSwatches(swatch) {
    const showEl = swatch.querySelector('[data-swatches-show]');
    const listEl = swatch.querySelector('[data-swatches-list]');
    const activeEl = swatch.querySelector('[data-swatches-active]');

    // on more click, show options
    showEl.addEventListener('click', () => (listEl.hidden = false));

    // on update, update label
    swatch.addEventListener('change', (event) => {
      activeEl.innerText = event.target.value;
    });
  }
}

customElements.define('color-swatches', ColorSwatches);

class ProductGridContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.gridId = this.getAttribute('data-container-id');
    this.productGridContainer = this.querySelector("#" + this.gridId);
    this.setInitialGridState();
  }

  setInitialGridState(){
    const moddleToggleMode = getCookie("ModdleToggle");
    if(moddleToggleMode)
    {
      if(moddleToggleMode == "show")
      {
        this.productGridContainer.classList.remove('is-secondary-image-visible');
      }
      else if (moddleToggleMode == "hide")
      {
        this.productGridContainer.classList.add('is-secondary-image-visible');
      }
    }
  }
}

customElements.define('product-grid-container', ProductGridContainer);

class ModelToggles extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.gridId = this.getAttribute('for');
    this.toggleButtons = this.querySelectorAll('button');
    this.showButton = this.toggleButtons[0];
    this.hideButton = this.toggleButtons[1];
    this.modelsHidden = this.hideButton.classList.contains('is-active');

    this.showButton.addEventListener('click', this.onShowClick.bind(this));
    this.hideButton.addEventListener('click', this.onHideClick.bind(this));
    this.setInitialGridState();
  }

  onShowClick(event) {
    event.preventDefault();
    this.gridId = this.getAttribute('for');
    this.modelsHidden = false;
    this.showButton.classList.add('is-active');
    this.hideButton.classList.remove('is-active');

    this.setGridState();
    setCookie("ModdleToggle","show",30);
  }

  onHideClick(event) {
    event.preventDefault();
    this.gridId = this.getAttribute('for');
    this.modelsHidden = true;
    this.hideButton.classList.add('is-active');
    this.showButton.classList.remove('is-active');

    this.setGridState();
    setCookie("ModdleToggle","hide",30);
  }

  setGridState() {
    const gridEl = document.getElementById(this.gridId);
    const classTarget = gridEl.closest('#ProductGridContainer') || gridEl;
    classTarget.classList.toggle('is-secondary-image-visible', this.modelsHidden);
  }

  setInitialGridState(){
    const moddleToggleMode = getCookie("ModdleToggle");
    const gridEl = document.getElementById(this.gridId);
    const classTarget = gridEl.closest('#ProductGridContainer') || gridEl;
    if(moddleToggleMode)
    {
      if(moddleToggleMode == "show")
      {
        this.showButton.classList.add('is-active');
        this.hideButton.classList.remove('is-active');
      }
      else if (moddleToggleMode == "hide")
      {
        this.showButton.classList.remove('is-active');
        this.hideButton.classList.add('is-active');
      }
    }
  }
}

customElements.define('model-toggle', ModelToggles);

class QuickBuy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('button');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!this.buttons.length) {
      return;
    }

    for (const button of this.buttons) {
      button.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(event) {
    event.preventDefault();
    this.variantIds = this.getAttribute('variant-ids');
    this.properties = this.getAttribute('line-item-props');

    if (!this.variantIds) {
      return;
    }

    for (const button of this.buttons) {
      button.setAttribute('disabled', true);
      button.classList.add('loading');
    }

    const quantityEl = this.querySelector('input[name="quantity"]');
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1;

    let properties;
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties);
      } catch (err) {
        console.error(err);
      }
    }

    let itemsObj = [];
    const varIdsArr = this.variantIds.split(',');
    varIdsArr.forEach((varId) => {
      itemsObj.push({
        id: varId,
        quantity: quantity,
        properties: properties,
      });
    });

    let body = {
      items: itemsObj,
    };

      if(window.Tapcart && window.Tapcart.isInitialized) {
       

        try{
              let tapCartItemsObj = [];
              varIdsArr.forEach((varId) => {
                tapCartItemsObj.push({
                  variantId: varId,
                  quantity: quantity
                });
              });
               
              window.Tapcart.actions.addToCart({
                lineItems: tapCartItemsObj
              });
            
              window.Tapcart.actions.openScreen({
                  destination: { 
                    type: "internal", 
                    url: "/cart"
                  }
              });
        }
        catch (error) {
          console.error('Error adding to cart via Tapcart:', error);
          
          const errorMessage = error.message || 'An error occurred while adding to cart via Tapcart.';
          if (errorMessage) {
            if (window.Shopify.theme.helpers.alert) {
              window.Shopify.theme.helpers.alert(errorMessage);
            } else {
              alert(errorMessage);
            }
          }
        }
        finally {
          for (const button of this.buttons) {
            button.classList.remove('loading');
            button.removeAttribute('disabled');
          }
          
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        }
 
 
     } else {
      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
  
      body = JSON.stringify(body);
  
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (!parsedState.items && parsedState.message) {
            const errorMessage = parsedState.description;
            console.error('Cart error', errorMessage);
            this.dispatchEvent(
              new CustomEvent('quick-buy-done', { bubbles: true, detail: { status: 'error', info: parsedState } })
            );
            if (errorMessage) {
              if (window.Shopify.theme.helpers.alert) {
                window.Shopify.theme.helpers.alert(errorMessage);
              } else {
                alert(errorMessage);
              }
            }
            return;
          }
  
          this.dispatchEvent(
            new CustomEvent('add-to-cart', {
              bubbles: true,
              detail: {
                status: 'success',
                source: 'quick-buy',
                items: parsedState.items,
              },
            })
          );
  
          this.dispatchEvent(new CustomEvent('quick-buy-done', { bubbles: true, detail: { status: 'success' } }));
  
          // if quick buy is in modal, close it by default (unless flagged with data-leave-open-with-cart)
          this.closest('modal-dialog:not([data-leave-open-with-cart])')?.hide();
  
          this.cart?.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
          this.dispatchEvent(
            new CustomEvent('quick-buy-done', { bubbles: true, detail: { status: 'error', error: error } })
          );
        })
        .finally(() => {
          for (const button of this.buttons) {
            button.classList.remove('loading');
            button.removeAttribute('disabled');
          }
          if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
     }
  }
}

customElements.define('quick-buy', QuickBuy);

class VariantSelectMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productCard = this.closest('product-card');
    this.modalOpener = this.querySelector('modal-opener, pop-menu button');
    this.modalTarget = this.modalOpener?.dataset.modal;
    this.modal = document.querySelector(this.modalTarget);
    this.popMenu = this.querySelector('pop-menu');
    this.modalCloser = this.modal?.querySelector('button[id^="ModalClose"]');
    this.variantSelects = this.modal
      ? this.modal.querySelectorAll('[data-variant-select]')
      : this.querySelectorAll('[data-variant-select]');
    this.variantLabels = this.querySelectorAll('[data-selected-label]');
    this.quickBuy = this.querySelector('quick-buy');
    this.quickBuyButtons = this.quickBuy?.querySelectorAll('button');
    this.wishListTarget = this.getAttribute('data-wishlist-button');
    this.wishListBtn = document.querySelector(this.wishListTarget);

    for (const variantSelect of this.variantSelects) {
      variantSelect.addEventListener('click', this.onSelectClick.bind(this));
    }

    this.modalOpener?.addEventListener('click', this.open.bind(this, true));
    this.menuOpener?.addEventListener('click', this.open.bind(this, true));
    this.modalCloser?.addEventListener('click', this.close.bind(this, false));

    if (this.modal) this.moveModal();
  }

  open() {
    this.productCard?.classList.add('is-variant-select-open');

    // close menu on next click regardless (selection made / click on body)
    // needs timeout or fires immediately (on click event this responds to)
    setTimeout(() => {
      document.body.addEventListener('click', this.close.bind(this), { once: true });
    });
  }

  close() {
    this.modal?.hide();
    this.popMenu?.hide();
    this.productCard?.classList.remove('is-variant-select-open');
  }

  moveModal() {
    // move modal to appropriate parent el for styling
    if (this.modal.matches('[id^="MobileQuickAdd"]')) {
      document.body.appendChild(this.modal);
    } else {
      const modalParent = this.closest('.card').querySelector('.card__inner');
      modalParent.appendChild(this.modal);
    }
  }

  onSelectClick(event) {
    event.preventDefault();

    const variantId = event.target.dataset.variantId;
    const variantLabel = event.target.dataset.variantSelect;
    const variantAvailable = !(event.target.disabled || event.target.classList.contains('disabled'));

    for (const variantLabelEl of this.variantLabels) {
      variantLabelEl.classList.remove('placeholder-text');
      variantLabelEl.innerHTML = variantLabel;
    }
    this.quickBuy.setAttribute('variant-ids', variantId);

    for (const button of this.quickBuyButtons) {
      button.disabled = !variantAvailable;
      if (button.querySelector('[data-button-label]')) {
        button.querySelector('[data-button-label]').innerText = variantAvailable
          ? window.variantStrings.addToCart
          : window.variantStrings.unavailable;
      }
    }

    this.wishListBtn?.changeVariant({ variantId });
    this.close();
  }
}

customElements.define('variant-select-menu', VariantSelectMenu);

class DataScrollIndicator extends HTMLElement {
  constructor() {
    super();

    this.indicator = this.querySelector('[data-scroll-indicator]');
    this.scroller = this.querySelector('[data-scroll-indicator-source]');

    this.buttons = this.indicator.querySelectorAll('button[data-target]');

    if (this.buttons.length) {
      Array.from(this.buttons).forEach((btn) => {
        btn.addEventListener('click', this.onBtnClick.bind(this));
      });
    }

    if (!this.indicator || !this.scroller) {
      return;
    }

    this.scroller.addEventListener('scroll', (event) => {
      requestAnimationFrame(this.onScroll.bind(this, event));
    });

    this.calcHeight();

    window.addEventListener('resize', () => {
      requestAnimationFrame(this.calcHeight.bind(this));
    });
  }

  onBtnClick(event) {
    event.preventDefault();
    let targetId = event.target.dataset.target;
    if (!targetId) targetId = event.target.closest('[data-target]')?.dataset.target;
    if (!targetId) return;
    const targetEl = this.scroller.querySelector(`[data-media-id="${targetId}"]`);
    targetEl?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  calcHeight() {
    const windowPercent = window.innerHeight / (this.scroller.scrollHeight / 100);
    this.indicator.style.setProperty('--scroll-indicator-height', windowPercent + '%');
  }

  onScroll(event) {
    const scrollComplete = this.scroller.scrollTop / (this.scroller.scrollHeight / 100);
    this.indicator.style.setProperty('--scroll-indicator-top', scrollComplete + '%');
  }
}
customElements.define('data-scroll-indicator', DataScrollIndicator);

class TabToggles extends HTMLElement {
  constructor() {
    super();
    this.updateUrl = this.dataset.updateUrl !== undefined;
  }

  connectedCallback() {
    // Helper to scope elements to THIS instance only (ignore nested instances)
    const within = (selector) =>
      Array.from(this.querySelectorAll(selector)).filter(
        (el) => el.closest('tab-toggles') === this
      );

    // Only pick up elements that belong to this instance
    this.tabs = within('[data-tab]');
    this.toggles = within('[data-tab-toggle]');
    this.selects = within('[data-tab-select]');

    if (!this.tabs.length) return;

    this.onToggleClick = this.onToggleClick.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);

    this.toggles.forEach((x) => x.addEventListener('click', this.onToggleClick));
    this.selects.forEach((x) => x.addEventListener('change', this.onSelectChange));

    if (this.updateUrl) {
      this.checkRestore();
    }
  }

  checkRestore() {
    if (!window.location.hash) return;
    this.showTab(window.location.hash);
  }

  onSelectChange(event) {
    event.preventDefault();
    event.stopPropagation();
    this.showTab(event.currentTarget.value);
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const selector = event.currentTarget.getAttribute('href') || event.currentTarget.dataset.for;
    this.showTab(selector);
  }

  showTab(selector) {
    if (!selector) return;

    const cleanSelector = `#${String(selector).replace('#', '').trim()}`;

    // Resolve the target strictly from THIS instance's tabs
    const targetTab = this.tabs.find((t) => `#${t.id}` === cleanSelector);
    if (!targetTab) return;

    if (this.updateUrl) {
      history.pushState(null, '', cleanSelector); // updates hash without scrolling
    }

    // Toggle active state only on THIS instance's controls
    this.toggles.forEach((x) => {
      const forVal = x.getAttribute('href') || x.dataset.for || '';
      x.classList.toggle('is-active', forVal.replace('#', '') === targetTab.id);
    });

    // Show/hide only THIS instance's tabs
    this.tabs.forEach((tab) => {
      tab.hidden = tab !== targetTab;
    });

    // Sync selects within THIS instance
    this.selects.forEach((x) => (x.value = cleanSelector));
  }
}

customElements.define('tab-toggles', TabToggles);


class GiftingTimeToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.btnNow = this.querySelector('[data-now-button]');
    this.dateInput = this.querySelector('[data-date-input]');
    this.dataIsoDate = this.querySelector('[data-iso-date]');


    this.btnNow.addEventListener('click', this.onDateNowClick.bind(this));
    this.dateInput.addEventListener('change', this.dateInputChanged.bind(this));

  }

  onDateNowClick(event) {
    event.preventDefault();
    this.dateInput.classList.remove("is-active");
    this.dateInput.classList.remove("has-value");
    this.dateInput.value = null;
    this.dataIsoDate.removeAttribute("name");
    this.dataIsoDate.value = null;
    this.dateInput.removeAttribute('name');
    this.btnNow.classList.add("is-active");
  }

  dateInputChanged(event) {
    this.dateInput.classList.add("is-active");
    this.dateInput.classList.add("has-value");
    this.btnNow.classList.remove("is-active");
    // this.dateInput.setAttribute('name', 'properties[_gift_send_at]');
  }

}

customElements.define('gifting-time-toggle', GiftingTimeToggle);

class GiftPopupImages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectedImg = this.querySelector('[data-selected-img]');
    this.optionBtns1 = this.querySelector('[data-option-1]');
    this.optionBtns2 = this.querySelector('[data-option-2]');
    this.optionBtns3 = this.querySelector('[data-option-3]');
    this.optionBtns4 = this.querySelector('[data-option-4]');
    this.giftImgInput = this.querySelector('[name="properties[_gift_image]"]');

    this.optionBtns1.addEventListener('click', this.onOptionClick.bind(this));
    this.optionBtns2.addEventListener('click', this.onOptionClick.bind(this));
    this.optionBtns3.addEventListener('click', this.onOptionClick.bind(this));
    this.optionBtns4.addEventListener('click', this.onOptionClick.bind(this));

  }

  onOptionClick(event){
    const src = event.target.src;
    const selectedImgTag = this.selectedImg.querySelector("img");
    selectedImgTag.setAttribute("src", src);
    selectedImgTag.setAttribute("srcset", "");
    if(this.giftImgInput){
      this.giftImgInput.value = src;
    }
    
    this.optionBtns1.classList.remove("selected");
    this.optionBtns2.classList.remove("selected");
    this.optionBtns3.classList.remove("selected");
    this.optionBtns4.classList.remove("selected");


    event.target.classList.add("selected");
  }

}

customElements.define('gift-popup-images', GiftPopupImages);

class SimpleToggle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.toggles = this.querySelectorAll('[data-toggle]');
    this.toggles.forEach((x) => x.addEventListener('click', this.onToggleClick.bind(this)));
    this.toggleTarget = this.querySelector('[data-toggle-target]');
  }

  onToggleClick(event) {
    event.preventDefault();
    const toggle = event.currentTarget;
    if (this.toggleTarget) {
      return this.toggle(toggle);
    }
    const selector = toggle.getAttribute('data-toggle') || toggle.getAttribute('href') || toggle.dataset.for;
    const cleanSelector = `#${selector.replace('#', '').trim()}`;
    this.toggle(toggle, cleanSelector);
  }

  toggle(toggle, selector) {
    const target = this.toggleTarget || document.querySelector(selector);
    target?.toggleAttribute('hidden');
    toggle?.classList.toggle('is-active', !target.hidden);
  }
}

customElements.define('simple-toggle', SimpleToggle);

class InfoPanels extends HTMLElement {
  constructor() {
    super();

    this.panels = this.querySelectorAll('[data-panel]');
    this.toggles = this.querySelectorAll('[data-panels-toggle]');
    this.resets = this.querySelectorAll('[type="reset"]');
    this.initial = this.querySelector('[data-panel="initial"]');
    this.setBehaviour();
  }

  reset() {
    this.panels.forEach((panel) => (panel.hidden = true));
    this.initial.hidden = false;
  }

  setBehaviour() {
    Array.from(this.resets).forEach((reset) => {
      reset.addEventListener('click', (event) => {
        event.preventDefault();
        this.reset();
      });
    });
    Array.from(this.toggles).forEach((toggle) => {
      const targetPanel = toggle.getAttribute('data-panels-toggle');
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggle(targetPanel);
      });
      toggle.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.toggle(targetPanel);
        }
      });
    });
  }

  toggle(targetPanelSelector) {
    this.panels.forEach((panel) => (panel.hidden = true));
    const targetPanel = this.querySelector(targetPanelSelector);
    if (targetPanel) targetPanel.hidden = !targetPanel.hidden;
  }
}

customElements.define('info-panels', InfoPanels);

class GlobalDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keydown', this.trapFocus.bind(this));
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('[data-close-button], .drawer__close')?.addEventListener('click', this.close.bind(this));
    this.setDrawerLinks();
  }

  trapFocus(event) {
    if(!event.key){
      return;
    }
    if ( event.key.toLowerCase() !== "tab" ) {
      return;
    }

    var target = event.target;
    
    function isVisible(el) {
        while (el) {
            if (window.getComputedStyle(el).display === "none") {
                return false;
            }
            el = el.parentElement;
        }
        return true;
    }

    const focusables = [...this.querySelectorAll("input, select, textarea, button, a[href], [tabindex]:not([tabindex='-1'])")]
        .filter(isVisible);

    if ( event.shiftKey ) {
      if ( target == this || target == focusables[0] ) {

        event.preventDefault();
        focusables[focusables.length - 1].focus();
      }
    } else {
      if (target == this || target == focusables[focusables.length - 1]) {

        event.preventDefault();
        focusables[0].focus();

      }
    }
  }

  setDrawerLinks() {
    this.drawerLinks = document.querySelectorAll(`[href="#${this.id}"], [data-drawer-link="#${this.id}"]`);

    Array.from(this.drawerLinks).forEach((drawerLink) => {
      drawerLink.setAttribute('role', 'button');
      drawerLink.setAttribute('aria-haspopup', 'dialog');
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(drawerLink);
      });
      drawerLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(drawerLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.drawer__inner');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('global-drawer', GlobalDrawer);

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.isMultiVariant = false;
    document.addEventListener('wishlist-change', this.onWishlistChange.bind(this));
    if (this.getAttribute('track-variant-change') !== null) {
      document.addEventListener('variant-change', this.onVariantChange.bind(this));
    }
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('button');

    if (!this.buttons.length) {
      return;
    }

    this.buttons.forEach((x) => x.addEventListener('click', this.onClick.bind(this)));
    this.selectModal = document.querySelector('#WishlistSelectModal');
    this.selectComponent = this.selectModal?.querySelector('wishlist-select');
    this.createComponent = document.querySelector('wishlist-create');

    this.setProductData();
  }

  static lists = null;
  static isFetching = false;

  static fetchLists() {
    if (this.isFetching) return;

    this.isFetching = true;
    window.theme.wishlist.isFetching = true;

    window.theme.wishlist?.swat?.fetchLists({
      callbackFn: (lists) => {
        this.isFetching = false;
        window.theme.wishlist.isFetching = false;
        this.lists = lists;
        window.theme.wishlist.lists = lists;

        document.dispatchEvent(new CustomEvent('lists-fetched', { bubbles: true, detail: { lists: lists } }));
      },
      errorFn: (error) => {
        console.error(error);
      },
    });
  }

  setProductData() {
    if (this.getAttribute('products-object')) {
      this.isMultiVariant = true;
      try {
        this.products = JSON.parse(this.getAttribute('products-object'));
      } catch (error) {
        console.error('Invalid products object', error);
      }
    } else {
      this.isMultiVariant = false;
      this.products = [
        {
          title: this.getAttribute('product-title'),
          variantId: this.getAttribute('variant-id'),
          productId: this.getAttribute('product-id'),
          handle: this.getAttribute('product-handle'),
          image: this.getAttribute('product-image'),
        },
      ];
      this.checkAddedState();
    }
  }

  static get observedAttributes() {
    return ['products-object'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'products-object') {
      this.isMultiVariant = true;
      let newJSON;
      try {
        newJSON = JSON.parse(newValue);
      } catch (error) {
        return console.error('Invalid products object', error);
      }
      this.products = newJSON;
      this.toggleActiveState(false);
    }
  }

  onWishlistChange(event) {
    if (this.isMultiVariant) {
      return;
    }
    // re-fetch lists and update button state to check if added/removed
    this.fetchlists(this.checkAddedState.bind(this));
  }

  onVariantChange(event) {
    if (this.isMultiVariant) {
      // don't track active variant when button adds multiple variants
      return;
    }

    const newVariant = event.detail.currentVariant.id;
    if (!newVariant) {
      return console.error('No new variant', event, newVariant);
    }
    this.changeVariant({ variantId: newVariant });
  }

  repopulate() {
    console.log('No product, re-populating');
    // sometimes the component loses data for unknown reasons.
    // In that case, re-populate it before proceeding
    this.setProductData();
    this.buttons = this.querySelectorAll('button');
  }

  changeVariant(variantObj) {
    if (!this.products[0] || !this.buttons) {
      this.repopulate();
    }

    this.products[0].title = variantObj.title || this.products[0].title;
    this.products[0].variantId = variantObj.variantId || this.products[0].variantId;
    this.products[0].productId = variantObj.productId || this.products[0].productId;
    this.products[0].handle = variantObj.productId || this.products[0].handle;
    this.products[0].image = variantObj.productId || this.products[0].image;

    this.setAttribute('product-title', this.products[0].title);
    this.setAttribute('variant-id', this.products[0].variantId);
    this.setAttribute('product-id', this.products[0].productId);
    this.setAttribute('product-handle', this.products[0].handle);
    this.setAttribute('product-image', this.products[0].image);

    for (const button of this.buttons) {
      button.disabled = false;
    }

    this.checkAddedState();
  }

  getVarIdsFromLists(lists) {
    let varIds = [];
    lists.forEach((x) => varIds.push(...x.listcontents));
    varIds = Array.from(new Set(varIds.map((x) => x.epi)));
    return varIds;
  }

  isVarIdInLists(varId, lists) {
    const varIds = this.getVarIdsFromLists(lists);
    return varIds.includes(parseInt(varId));
  }

  fetchlists(cb) {
    if (!window.theme.wishlist.swat) {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(this.fetchlists.bind(this, cb));
      return;
    }

    document.addEventListener(
      'lists-fetched',
      () => {
        cb(WishlistButton.lists);
      },
      { once: true }
    );
    WishlistButton.fetchLists();
  }

  checkAddedState() {
    if (this.isMultiVariant) {
      return;
    }

    if (!WishlistButton.lists) {
      return this.fetchlists(this.checkAddedState.bind(this));
    }

    if (!this.products[0]) {
      this.repopulate();
    }

    const isInList = this.isVarIdInLists(this.products[0].variantId, WishlistButton.lists);
    this.toggleActiveState(isInList);
  }

  toggleActiveState(toggle) {
    if (this.buttons === undefined) {
      return;
    }

    for (const button of this.buttons) {
      button.classList.toggle('is-active', toggle);
      if (button.querySelector('[data-button-label]')) {
        button.querySelector('[data-button-label]').innerText = toggle
          ? window.wishlistSettings.removeFromWishlist
          : window.wishlistSettings.addToWishlist;
      }
    }
  }

  toggleLoadState(toggle) {
    for (const button of this.buttons) {
      if (toggle) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', true);
      }
      button.classList.toggle('is-loading', !toggle);
    }
  }

  onError(error) {
    console.error(error);
  }

  onClick(event) {
    event.preventDefault();

    if (!window.theme.wishlist.swat) {
      return console.error('Wishlist not loaded');
    }

    this.setProductData();
    this.toggleLoadState(false);
    this.selectComponent.populateAndShow(
      WishlistButton.lists,
      this.products,
      undefined,
      this,
      this.toggleLoadState.bind(this, true)
    );
  }
}

customElements.define('wishlist-button', WishlistButton);

class OutfitBuilderLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.links = this.querySelectorAll('[href]');
    document.addEventListener('variant-change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const newVariant = event.detail.currentVariant.id;
    if (!newVariant) {
      return console.error('No new variant', event, newVariant);
    }
    for (const link of this.links) {
      const linkParts = link.href.split('?');
      const urlParams = new URLSearchParams(linkParts[1]);
      urlParams.set('variant', newVariant);
      const newLink = `${linkParts[0]}?${urlParams.toString()}`;
      link.href = newLink;
    }
  }
}
customElements.define('outfit-builder-link', OutfitBuilderLink);

class WishlistRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('button');

    if (!this.buttons.length) {
      return;
    }

    this.product = {
      variantId: this.getAttribute('variant-id'),
      productId: this.getAttribute('product-id'),
      handle: this.getAttribute('product-handle'),
      image: this.getAttribute('product-image'),
    };

    this.buttons.forEach((x) => x.addEventListener('click', this.onClick.bind(this)));
  }

  onClick(event) {
    event.preventDefault();

    if (!window.theme.wishlist?.swat) {
      return console.error('Wishlist not loaded');
    }

    this.buttons.forEach((x) => x.setAttribute('disabled', true));
    this.button.classList.add('is-loading');

    window.theme.wishlist?.swat?.fetchLists({
      callbackFn: this.onFetchLists.bind(this),
      errorFn: this.onError.bind(this),
    });
  }

  onFetchLists(lists) {
    this.lists = lists;

    this.lists.filter((x) => {
      return this.isVarIdInLists(this.product.variantId, [x]);
    });
    this.removeFromLists(this.lists, () => {
      this.buttons.forEach((x) => {
        x.removeAttribute('disabled');
        x.classList.remove('is-loading');
      });
      this.dispatchEvent(new CustomEvent('wishlist-change', { bubbles: true }));
    });
  }

  removeFromLists(lists, callback) {
    if (lists.length) {
      const listToRemove = lists.shift();
      return this.removeFromList(listToRemove, this.removeFromLists.bind(this, lists, callback));
    }
    callback && callback();
  }

  removeFromList(list, callback) {
    const listId = list.lid;
    const productObject = this.getProductObject();
    window.theme.wishlist.swat?.deleteFromList(
      listId,
      productObject,
      callback,
      this.onError.bind(this, listId, callback)
    );
  }

  getVarIdsFromLists(lists) {
    let varIds = [];
    lists.forEach((x) => varIds.push(...x.listcontents));
    varIds = Array.from(new Set(varIds.map((x) => x.epi)));
    return varIds;
  }

  isVarIdInLists(varId, lists) {
    const varIds = this.getVarIdsFromLists(lists);
    return varIds.includes(parseInt(varId));
  }

  getProductObject(products = [this.product]) {
    let productsObject = [];
    products.forEach((product) => {
      productsObject.push({
        epi: product.variantId,
        empi: product.productId,
        du: `https://${Shopify.shop}${Shopify.routes.root}products/${product.handle}`,
      });
    });
    return productsObject.length > 1 ? productsObject : productsObject[0];
  }

  onError(error) {
    console.error(error);

    this.buttons.forEach((x) => {
      x.removeAttribute('disabled');
      x.classList.remove('is-loading');
    });
  }
}

customElements.define('wishlist-remove-button', WishlistRemoveButton);

class WishlistCreate extends HTMLElement {
  constructor() {
    super();
    this.onCompleteCallback = null;
    this.productsToAdd = null;
    this.connectedSelectModal = null;
  }

  connectedCallback() {
    this.modalEl = this.closest('modal-dialog');
    this.createButtonEl = this.querySelector('button');
    this.nameFieldEl = this.querySelector('input');
    this.thumbContainer = this.querySelector('[data-wishlist-thumb]');

    this.createButtonEl.addEventListener('click', this.onCreateClick.bind(this));
    this.nameFieldEl.addEventListener('input', this.onFieldChange.bind(this));
  }

  onFieldChange(event) {
    event.preventDefault();
    if (this.nameFieldEl.value.length) {
      return (this.createButtonEl.disabled = false);
    }
    this.createButtonEl.disabled = true;
  }

  populateThumb() {
    const imageSrc = this.productsToAdd[0].image;
    if (imageSrc) {
      this.thumbContainer.innerHTML = `
      <img
        src="${imageSrc}&width=128"
        srcset="
          ${imageSrc}&width=64 64w,
          ${imageSrc}&width=128 128w"
        height="64"
        loading="lazy"
        sizes="64px"
      >
    `;
    } else {
      this.thumbContainer.innerHTML = ``;
    }
  }

  openTasks() {
    this.nameFieldEl.value = '';
    this.populateThumb();
    this.modalEl?.show();
    setTimeout(() => {
      this.nameFieldEl.focus();
    });
  }

  openModalAndReturnToSelect(selectModal) {
    this.connectedSelectModal = selectModal;
    this.productsToAdd = selectModal.products;
    this.openTasks();
    this.onCompleteCallback = () => {
      selectModal.populateAndShow();
    };
  }

  openModal(productsToAdd, selectModal = null, callback) {
    this.productsToAdd = productsToAdd;
    this.connectedSelectModal = selectModal;
    this.openTasks();
    this.onCompleteCallback = callback;
  }

  closeModal() {
    this.modalEl.hide();
  }

  getProductObject(products = this.products) {
    let productsObject = [];
    products.forEach((product) => {
      productsObject.push({
        epi: product.variantId,
        empi: product.productId,
        du: `https://${Shopify.shop}${Shopify.routes.root}products/${product.handle}`,
      });
    });
    return productsObject.length > 1 ? productsObject : productsObject[0];
  }

  addToList(productsToAdd, listId, callback) {
    const productObject = this.getProductObject(productsToAdd);
    const callbackValue = callback ? callback.bind(this, listId) : null;
    if (productObject.length) {
      window.theme.wishlist.swat?.addProductsToList(
        listId,
        productObject,
        callbackValue,
        this.onError.bind(this, listId, callbackValue)
      );
    } else if (productObject) {
      window.theme.wishlist.swat?.addToList(
        listId,
        productObject,
        callbackValue,
        this.onError.bind(this, listId, callbackValue)
      );
    }
    this.dispatchEvent(
      new CustomEvent('wishlist-add', {
        bubbles: true,
        detail: {
          products: productsToAdd,
        },
      })
    );
  }

  onCreateClick(event) {
    event.preventDefault();
    const listName = this.nameFieldEl.value;
    this.createButtonEl.disabled = true;
    this.createButtonEl.classList.add('is-loading');
    window.theme.wishlist.swat?.createList({ lname: listName }, this.onSuccess.bind(this), this.onError.bind(this));
  }

  onSuccess(response) {
    // check if we came from a select modal and have products to add
    if (!this.productsToAdd && this.connectedSelectModal) {
      this.productsToAdd = this.connectedSelectModal.products;
    }
    if (this.productsToAdd) {
      return this.addToList(this.productsToAdd, response.lid, () => {
        this.dispatchEvent(new CustomEvent('wishlist-change', { bubbles: true }));
        if (this.onCompleteCallback) {
          this.onCompleteCallback(response);
        }
        this.connectedSelectModal?.connectedButton?.toggleActiveState(true);
        this.onComplete();
      });
    }
    if (this.onCompleteCallback) {
      this.onCompleteCallback(response);
    }
    this.onComplete();
  }

  onComplete() {
    this.createButtonEl.disabled = false;
    this.createButtonEl.classList.remove('is-loading');
    this.closeModal();
  }

  onError(error) {
    console.error(error);
  }
}

customElements.define('wishlist-create', WishlistCreate);

class WishlistSelect extends HTMLElement {
  constructor() {
    super();
    this.lists = null;
    this.connectedButton = null;
    this.notifyTimeMs = 3000;
  }

  connectedCallback() {
    this.modalEl = this.closest('modal-dialog');
    this.createModal = document.querySelector('#WishlistCreateModal');
    this.createComponent = document.querySelector('wishlist-create');
    this.selectModal = document.querySelector('#WishlistSelectModal');

    this.optionsEl = this.querySelector('[data-wishlist-select-options]');
    this.newBtns = this.querySelectorAll('[data-wishlist-select-new]');
    this.startScreen = this.querySelector('[data-lists-start]');
    this.listsBody = this.querySelector('[data-lists-body');

    this.notifyEl = this.querySelector('[data-notify]');
    this.notifyTextEl = this.querySelector('[data-notify-text]');

    for (const newBtn of this.newBtns) {
      newBtn.addEventListener('click', this.onNewClick.bind(this));
    }
  }

  addSelectHandlers() {
    this.selectButtons = this.querySelectorAll('button[data-list-id]');
    Array.from(this.selectButtons).forEach((x) => x.addEventListener('click', this.onSelectClick.bind(this)));
  }

  onSelectClick(event) {
    event.preventDefault();

    const buttonEl = event.target.matches('button') ? event.target : event.target.closest('button');
    const listId = buttonEl.dataset.listId;
    const isInList = buttonEl.classList.contains('is-active');

    this.classList.add('is-loading');
    buttonEl?.classList.add('is-changing');

    for (const button of this.selectButtons) {
      button.setAttribute('disabled', true);
    }

    // .is-active is never applied when there are multiple variantIds, so below allows
    // always adding when there are multiple inputs, toggling when there is 1
    if (isInList) {
      this.removeFromList(listId);
    } else {
      this.addToList(listId);
    }
  }

  getProductObject(products = this.products) {
    let productsObject = [];
    products.forEach((product) => {
      productsObject.push({
        epi: product.variantId,
        empi: product.productId,
        du: `https://${Shopify.shop}${Shopify.routes.root}products/${product.handle}`,
      });
    });
    return productsObject.length > 1 ? productsObject : productsObject[0];
  }

  removeFromList(listId, callback) {
    const productObject = this.getProductObject();
    if (this.variantIds.length > 1) {
      window.theme.wishlist.swat?.removeProductsFromList(
        listId,
        productObject,
        this.onRemoveSuccess.bind(this, listId, callback),
        this.onError.bind(this, listId, callback)
      );
    } else {
      window.theme.wishlist.swat?.deleteFromList(
        listId,
        productObject,
        this.onRemoveSuccess.bind(this, listId, callback),
        this.onError.bind(this, listId, callback)
      );
    }

    this.modalEl.hide();
  }

  addToList(listId, callback) {
    const productObject = this.getProductObject();
    const callbackValue = callback ? callback.bind(this, listId) : null;
    if (productObject.length) {
      window.theme.wishlist.swat?.addProductsToList(
        listId,
        productObject,
        this.onAddSuccess.bind(this, listId, callbackValue),
        this.onError.bind(this, listId, callbackValue)
      );
    } else if (productObject) {
      window.theme.wishlist.swat?.addToList(
        listId,
        productObject,
        this.onAddSuccess.bind(this, listId, callbackValue),
        this.onError.bind(this, listId, callbackValue)
      );
    }
    this.dispatchEvent(
      new CustomEvent('wishlist-add', {
        bubbles: true,
        detail: {
          products: this.products,
        },
      })
    );

    this.modalEl.hide();
  }

  fetchlists(callback) {
    if (!window.theme.wishlist.swat) {
      return console.info('Wishlist not loaded');
    }

    window.theme.wishlist.swat?.fetchLists({
      callbackFn: (lists) => {
        this.lists = lists;
        if (callback) callback(lists);
      },
      errorFn: this.onError.bind(this),
    });
  }

  onNewClick(event) {
    event.preventDefault();
    this.modalEl.hide();
    this.createComponent.openModal(this.products, this);
  }

  notifyToggle(toggle, notifyText) {
    this.notifyEl.hidden = false;
    this.notifyEl.classList.toggle('animate-in-out', !toggle);
    if (notifyText) this.notifyTextEl.innerHTML = notifyText;

    if (!toggle) return;

    clearTimeout(this.notifyCloseTimeout);
    this.notifyCloseTimeout = setTimeout(() => {
      this.notifyToggle(false);
    }, this.notifyTimeMs);
  }

  onAddSuccess(listId, callback, response) {
    const numProds = response.length || 1;
    const listEl = this.querySelector(`[data-list-id="${listId}"]`);
    const list = this.lists.find((x) => x.lid === listId);

    // notify
    const listName = list ? list.lname : 'collection';
    const notifyText = `Added to ${listName}`;
    this.notifyToggle(true, notifyText);

    // update item count
    const listCountEl = listEl.querySelector(`[data-list-count]`);
    listCountEl.innerHTML = parseInt(listCountEl.innerText) + numProds;

    // enable UI
    const allButtons = [...Array.from(this.selectButtons), ...Array.from(this.newBtns)];
    for (const button of allButtons) {
      button.removeAttribute('disabled');
    }
    this.classList.remove('is-loading');
    listEl?.classList.remove('is-changing');
    listEl?.classList.add('is-active');

    this.connectedButton?.toggleActiveState(true);

    this.dispatchEvent(new CustomEvent('wishlist-change', { bubbles: true, detail: { listId, response } }));

    if (callback) {
      callback();
    }
  }

  onRemoveSuccess(listId, callback, response) {
    const numProds = response.length || 1;
    const listEl = this.querySelector(`[data-list-id="${listId}"]`);
    const list = this.lists.find((x) => x.lid === listId);

    // notify
    const listName = list ? list.lname : 'collection';
    const notifyText = `Removed from ${listName}`;
    this.notifyToggle(true, notifyText);

    // update item count
    const listCountEl = listEl.querySelector(`[data-list-count]`);
    listCountEl.innerHTML = parseInt(listCountEl.innerText) - numProds;

    // enable UI
    listEl?.classList.remove('is-active', 'is-changing');
    const allButtons = [...Array.from(this.selectButtons), ...Array.from(this.newBtns)];
    for (const button of allButtons) {
      button.removeAttribute('disabled');
    }
    this.classList.remove('is-loading');

    if (!this.querySelector(`[data-list-id].is-active`)) {
      this.connectedButton?.toggleActiveState(false);
    }

    this.dispatchEvent(new CustomEvent('wishlist-change', { bubbles: true, detail: { listId, response } }));

    if (callback) {
      callback();
    }
  }

  onError(error) {
    console.error(error);
  }

  populateAndShow(lists, products = this.products, listsExclude = [], connectedButton, callback) {
    if (!lists) {
      return this.fetchlists((lists) => this.populateAndShow(lists, products, listsExclude, connectedButton, callback));
    }

    this.connectedButton = connectedButton;
    lists = lists.filter((x) => !listsExclude.includes(x.lid));
    this.populate(lists, products);
    this.modalEl.show();
    if (callback) callback();
  }

  populate(lists, products) {
    this.lists = lists;
    this.products = products;
    this.variantIds = products.map((x) => x.variantId);
    let markup = ``;
    let isInAnyList = false;

    if (lists && lists.length === 0) {
      this.startScreen.hidden = false;
      this.listsBody.hidden = true;
      return;
    }

    lists.forEach((list) => {
      const imageSrc = list.listcontents[0]?.iu?.replace(/_\d\d\dx\d\d\d/, ''); // remove fixed size "_620x620"
      const listCount = list.listcontents.length;
      const listTitle = list.lname;
      const listId = list.lid;

      let isInList = false;

      if (this.variantIds.length === 1) {
        const variantId = parseInt(this.variantIds[0]);
        isInList = !!list.listcontents.find((x) => x.epi === variantId);
      } else {
        isInList = !this.variantIds.some((id) => {
          return !list.listcontents.find((x) => x.epi === parseInt(id));
        });
      }

      isInAnyList = isInList || isInAnyList;

      let noRemove = false;
      if (isInList && list.listcontents.length === this.variantIds.length) {
        noRemove = true;
      }

      markup += html`
        <li class="wishlist-select-modal__item color-background-1">
          <button
            type="button"
            data-list-id="${listId}"
            class="button-invisible ${isInList ? `is-active` : ``}${noRemove ? ` disabled` : ``}"
          >
            <div
              class="wishlist-select-modal__item-thumb aspect-ratio-box color-background-1"
              style="--aspect-ratio: 0.667;"
            >
              ${imageSrc
          ? `
                  <img
                    src="${imageSrc}&width=80"
                    width="80"
                    height="120"
                    sizes="80px"
                    loading="lazy"
                    srcset="${imageSrc}&width=80 80w, ${imageSrc}&width=160 160w"
                  />
                `
          : ``}
            </div>
            <div class="wishlist-select-modal__item-title">
              <div class="ui-large">${listTitle}</div>
              <div class="ui-standard"><span data-list-count>${listCount}</span> Items</div>
            </div>
            <div class="wishlist-select-modal__item-icon">
              <svg class="icon icon-bookmark-large" width="8" height="16" viewBox="0 0 16 32" fill="none">
                <path stroke="currentColor" d="M.5.5h15v30.092l-6.724-8.276a1 1 0 0 0-1.552 0L.5 30.592V.5Z" />
              </svg>
            </div>
          </button>
        </li>
      `;
    });
    this.optionsEl.innerHTML = markup;
    this.startScreen.hidden = true;
    this.listsBody.hidden = false;
    this.connectedButton?.toggleActiveState(isInAnyList);
    this.addSelectHandlers();
  }
}

customElements.define('wishlist-select', WishlistSelect);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.hasImpression = false;
  }

  connectedCallback() {
    const productGrid = this.closest('ul.grid');
    this.cardIndex = productGrid ? Array.from(productGrid.children).indexOf(this.closest('li.grid__item')) + 1 : null;
    this.cardContext = this.getAttribute('context');
    this.swatches = this.querySelectorAll('[data-swatch-link]');

    let productData = this.getAttribute('product-data');
    try {
      this.productData = productData ? JSON.parse(productData) : null;
    } catch (error) {
      console.error('Invalid share event data', productData);
      this.productData = null;
    }

    for (const swatch of this.swatches) {
      swatch.addEventListener('click', this.onSwatchClick.bind(this));
    }

    this.addEventListener('click', this.onClick.bind(this));

    if (this.cardContext === 'collection-list') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.trackImpression.bind(this));
      } else {
        this.trackImpression();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.trackImpression.bind(this));
  }

  trackImpression() {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // timeout to avoid running intersection logic if fast scrolling
          this.requestTimeout = setTimeout(async () => {
            if (!this.hasImpression) {
              this.hasImpression = true;
              this.onImpression();
              // once impression is made, unobserve
              observer.unobserve(this);
            }
          }, 250);
        } else {
          clearTimeout(this.requestTimeout);
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: `0px 0px 0px 0px`,
      threshold: 1,
    });
    observer.observe(this);
  }

  onSwatchClick(event) {
    const swatchEl = event.target;
    // allow clicks to PDP through on active/loading swatches. swatches respond to user intent regardless of network
    if (swatchEl.classList.contains('is-active') || swatchEl.classList.contains('is-loading')) return;
    event.preventDefault();
    const productUrl = swatchEl.href;
    this.toggleSwatchLoad(true);

    fetch(`${productUrl}?view=json-schema`)
      .then((response) => response.json())
      .then((product) => {
        this.toggleSwatchLoad(false);
        this.changeActiveSwatch(swatchEl);
        const newCardEl = this.getNewCard(product, false);
        this.replaceCard(newCardEl); // destroys this component, call last
      })
      .catch((error) => {
        console.error(error);
        this.toggleSwatchLoad(false);
      });
  }

  toggleSwatchLoad(toggle) {
    Array.from(this.swatches).forEach((el) => el.classList.toggle('is-loading', toggle));
  }

  changeActiveSwatch(swatchEl) {
    Array.from(this.swatches).forEach((el) => el.classList.remove('is-active'));
    swatchEl.classList.add('is-active');
  }

  getNewCard(productObj, preserveSwatches, preserveCardClasses = true, preserveRatio = true, preserveQuickATC = true) {
    const cardMarkup = window.Shopify.theme.helpers.getProductCardMarkup(productObj, null, this.cardContext);
    const cardEl = new DOMParser().parseFromString(cardMarkup, 'text/html').querySelector('product-card');

    // getProductCardMarkup has no swatches/access to stitch collections and returns
    // empty swatch containers. this populates them from original card
    if (preserveSwatches) {
      const swatchSelectors = ['.card__swatches', '.card__swatches-mobile'];
      swatchSelectors.forEach((s) => {
        // can't use .replaceWith, not reliable
        const container = cardEl.querySelector(s);
        if (!container) return;
        container.innerHTML = this.querySelector(s)?.innerHTML || '';
        container.hidden = false;
      });
    }
    // remove mobile QATC if not present on original
    if (!this.querySelector('.quick-add__mobile')) {
      cardEl.querySelector('.quick-add__mobile').remove();
    }
    // maintains custom style classes of original
    if (preserveCardClasses) {
      cardEl.className = this.className;
      cardEl.querySelector('.card').className = this.querySelector('.card').className;
    }
    // maintains aspect ratio of original
    if (preserveRatio) {
      cardEl.querySelector('.card').setAttribute('style', this.querySelector('.card').getAttribute('style'));
    }
    // maintains quick ATC of original
    if (preserveQuickATC) {
      if (!this.querySelectorAll('.quick-add').length) {
        for (const el of cardEl.querySelectorAll('.quick-add')) {
          el.remove();
        }
      }
    }
    return cardEl;
  }

  /**
   * Replaces this card with el. To reliably replace must add new element
   * then destroy this component. Directly replacing (replaceWith) does not
   * work reliably over multiple replacements.
   */
  replaceCard(el) {
    this.before(el);
    this.remove();
  }

  onClick(event) {
    this.dispatchEvent(
      new CustomEvent('product-card-click', {
        bubbles: true,
        detail: {
          clickEvent: event,
          card: this,
          productData: this.productData,
          cardContext: this.cardContext,
          cardIndex: this.cardIndex,
        },
      })
    );
  }

  onImpression() {
    this.dispatchEvent(
      new CustomEvent('product-card-view', {
        bubbles: true,
        detail: {
          clickEvent: event,
          card: this,
          productData: this.productData,
          cardContext: this.cardContext,
          cardIndex: this.cardIndex,
        },
      })
    );
  }
}

customElements.define('product-card', ProductCard);

class CardMediaCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.carousel = this.querySelector('.js-carousel-list');
    this.productCard = this.closest('product-card, li.grid__item');
    this.prevButton = this.productCard.querySelector('.js-carousel-prev');
    this.nextButton = this.productCard.querySelector('.js-carousel-next');
    this.prevButton?.addEventListener('click', this.onPrevClick.bind(this));
    this.nextButton?.addEventListener('click', this.onNextClick.bind(this));
  }

  onPrevClick(e) {
    const activeSlide = this.carousel.querySelector('.card__media-slide--active');
    const prevSlide = activeSlide.previousElementSibling || this.carousel.lastElementChild;
    activeSlide.classList.remove('card__media-slide--active');
    prevSlide.classList.add('card__media-slide--active');
  }

  onNextClick(e) {
    const activeSlide = this.carousel.querySelector('.card__media-slide--active');
    const nextSlide = activeSlide.nextElementSibling || this.carousel.firstElementChild;
    activeSlide.classList.remove('card__media-slide--active');
    nextSlide.classList.add('card__media-slide--active');
  }
}

customElements.define('card-media-carousel', CardMediaCarousel);

class FormValidation extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.querySelector('form');
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.form.setAttribute('novalidate', 'novalidate');
    for (const el of this.form.elements) {
      el.addEventListener('change', this.onElementChange.bind(this));
    }
  }

  validateElement(el) {
    const label = document.querySelector(`label[for="${el.id}"]`) || el.closest('label');
    const errorMsg = document.getElementById(el.getAttribute('aria-describedby'));
    const innerMsg = errorMsg?.querySelector('.form__message') || errorMsg;
    // set flag for custom messages (if no custom message, browser default will be used)
    if (errorMsg && el.dataset.customMessage === undefined) {
      if (innerMsg.innerText.trim() === '') {
        el.dataset.customMessage = false;
      } else {
        el.dataset.customMessage = true;
      }
    }
    const customMessage = !!(el.dataset.customMessage === 'true');
    if ('checkValidity' in el === false) {
      return;
    }
    const elementValidity = el.checkValidity();
    if (elementValidity) {
      [label, el].forEach((x) => x?.classList?.remove('is-error'));
      if (errorMsg) {
        // only hide if there's no other invalid elements using this error message
        if (this.querySelectorAll(`[aria-describedby="${errorMsg.id}"].is-error`).length === 0) {
          errorMsg.hidden = true;
        }
      }
    } else {
      [label, el].forEach((x) => x?.classList?.add('is-error'));
      if (errorMsg) {
        // only populate with default message if no custom message is present
        if (!customMessage) {
          innerMsg.innerText = el.validationMessage;
          console.log(el.validationMessage);
        }
        errorMsg.hidden = false;
      } else {
        el.reportValidity();
      }
    }
    return elementValidity;
    // console.log(el, label, errorMsg, customMessage, el.checkValidity());
  }

  onElementChange(event) {
    this.validateElement(event.target);
  }

  onFormSubmit(event) {
    let isFocusInvalidEl = false;
    for (const el of this.form.elements) {
      const isValid = this.validateElement(el);
      if(!isValid && !isFocusInvalidEl){
        el.focus();
        isFocusInvalidEl = true;
      }
    }

    if (this.form.checkValidity()) {
      return console.log('OK');
    } else {
      event.preventDefault();
      console.log('Failed', event);
      return false;
    }
  }
}
customElements.define('form-validation', FormValidation);

class SocialShareLinks extends HTMLElement {
  constructor() {
    super();

    this.defaults = {
      width: 500,
      height: 500,
    };

    this.platforms = {
      whatsapp: {
        name: 'whatsapp',
        href: 'whatsapp://send?text=%URL%',
        width: null,
        height: null,
        sameWindow: true,
        imageRequired: false,
      },
      facebook: {
        name: 'facebook',
        href: 'https://www.facebook.com/sharer/sharer.php?u=%URL%',
        width: 400,
        height: 500,
        imageRequired: false,
      },
      twitter: {
        name: 'twitter',
        // href: 'https://twitter.com/intent/post?text=%TITLE%&url=%URL%&hashtags=%HASHTAGS%',
        href: 'https://twitter.com/intent/post?text=%TITLE%&url=%URL%',
        width: 540,
        height: 260,
        imageRequired: false,
      },
      pinterest: {
        name: 'pinterest',
        href: 'http://pinterest.com/pin/create/button/?url=%URL%&description=%TITLE%&media=%IMAGE%',
        width: 520,
        height: 570,
        imageRequired: true,
      },
      tumblr: {
        name: 'tumblr',
        href: 'http://www.tumblr.com/share/link?url=%URL%',
        width: 500,
        height: 500,
        imageRequired: true,
      },
      linkedin: {
        name: 'linkedin',
        href: 'https://www.linkedin.com/sharing/share-offsite/?url=%URL%',
        width: 520,
        height: 570,
        imageRequired: false,
      },
    };
    this.platforms.x = this.platforms.twitter;
  }

  connectedCallback() {
    this.setImage();
  }

  setImage() {
    if (this.shareImage) return;
    let image = '';
    let og_image = document.querySelector('meta[property="og:image"]');
    if (og_image) {
      image = og_image.getAttribute('content');
    } else {
      const images = document.getElementsByTagName('img');
      if (images.length > 0) {
        image = images[0].getAttribute('src');
      }
    }
    this.shareImage = image;
  }

  makeUrl(platform, url = this.shareUrl, title = this.shareTitle, image = this.shareImage) {
    const platformObj = this.platforms[platform];
    if (platformObj.imageRequired && !image) return false;
    const shareUrl = platformObj.href
      .replace('%URL%', encodeURIComponent(url).replace(/%20/g, '+'))
      .replace('%TITLE%', encodeURIComponent(title).replace(/%20/g, '+'))
      .replace('%IMAGE%', encodeURIComponent(image).replace(/%20/g, '+'));
    return shareUrl;
  }

  copyTextToClipboard(textToCopy) {
    if (navigator?.clipboard?.writeText) {
      return navigator.clipboard.writeText(textToCopy);
    }
    return Promise.reject('The Clipboard API is not available.');
  }

  onLinkClick(event) {
    const link = event.target.dataset.sharePlatform ? event.target : event.target.closest('[data-share-platform]');
    const openInNewWindow = !!(link.target === '_blank');
    const isLinkShare = !!(link.dataset.sharePlatform === 'link');

    if (isLinkShare) {
      event.preventDefault();
      return this.copyTextToClipboard(link.href)
        .then((response) => {
          link.setAttribute('aria-label', 'Copied to clipboard!');
        })
        .catch((error) => {
          console.error(error);
        });
    }

    if (!openInNewWindow) return;

    event.preventDefault();

    const platform = this.platforms[link.dataset.sharePlatform];
    const width = platform?.width | this.defaults.width;
    const height = platform?.height | this.defaults.height;

    window.open(link.href, '', 'status=yes, width=' + width + ', height=' + height);
  }
}

customElements.define('social-share-links', SocialShareLinks);

class ShareUrlForm extends SocialShareLinks {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.form = this.querySelector('form');
    this.emailInput = this.form.querySelector('[name="email"]');
    this.senderName = this.querySelector('input[name="sender_name"]');
    this.submitButton = this.form.querySelector('button');
    this.successMessage = this.querySelector('[data-success-msg]');
    this.successText = this.querySelector('[data-success-msg-text]');
    if (!this.form || !this.emailInput) return;
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.emailInput.addEventListener('input', this.checkValidEmail.bind(this));
    this.checkValidEmail();
  }

  populate(shareData) {
    this.successMessage.hidden = true;
    this.form.hidden = false;
    this.shareTitle = shareData.title || window.document.title;
    this.shareUrl = shareData.url || window.location.href;
    this.shareSuccessMessage = shareData.successMessage || window.themeStrings.shareModal.formSuccessMessage;
    this.shareEventName = shareData.eventName || 'Share Modal Submission';

    try {
      this.shareEventData = shareData.eventData ? JSON.parse(shareData.eventData) : null;
    } catch (error) {
      console.error('Invalid share event data', shareData.eventData);
      this.shareEventData = null;
    }

    this.shareImage = shareData.image;
    if (!this.shareImage) {
      super.setImage();
    }

    if (this.successText && this.shareSuccessMessage) {
      this.successText.innerText = this.shareSuccessMessage;
    }

    this.setShareUrls();
  }

  setShareUrls(shareData) {
    const shareEls = document.querySelectorAll('[data-share-link]');

    this.shareUrl = shareData?.url || this.shareUrl;
    this.shareTitle = shareData?.title || this.shareTitle;
    this.shareImage = shareData?.image || this.shareImage;

    for (const shareEL of shareEls) {
      const linkEl = shareEL.querySelector('a');
      if (!linkEl) continue;
      linkEl.addEventListener('click', this.onLinkClick.bind(this));
      let shareUrl;
      switch (shareEL.dataset.shareLink) {
        case 'pinterest':
          shareUrl = this.makeUrl('pinterest');
          if (!shareUrl) break;
          linkEl.href = shareUrl;
          shareEL.hidden = false;
          break;
        case 'facebook':
          shareUrl = this.makeUrl('facebook');
          if (!shareUrl) break;
          linkEl.href = shareUrl;
          shareEL.hidden = false;
          break;
        case 'linkedin':
          shareUrl = this.makeUrl('linkedin');
          if (!shareUrl) break;
          linkEl.href = shareUrl;
          shareEL.hidden = false;
          break;
        case 'x':
          shareUrl = this.makeUrl('twitter');
          if (!shareUrl) break;
          linkEl.href = shareUrl;
          shareEL.hidden = false;
          break;
        case 'link':
          linkEl.href = this.shareUrl;
          shareEL.hidden = false;
          break;
        case 'instagram':
          break;
      }
    }
  }

  checkValidEmail() {
    if (!this.submitButton) return;
    if (this.emailInput.checkValidity()) {
      return (this.submitButton.disabled = false);
    }
    this.submitButton.disabled = true;
  }

  async onFormSubmit(event) {
    event.preventDefault();

    const data = {
      EmailRecipient: this.emailInput.value,
      ShareUrl: this.shareUrl,
      ShareImage: this.shareImage,
      ShareTitle: this.shareTitle,
      ShareData: this.shareEventData,
    };

    console.log('Sending', this.shareEventName, data);

    if (typeof klaviyo !== 'undefined') {
      try {
        const response = await klaviyo.track(this.shareEventName, data);
        console.log('Sent to Klaviyo', response);
      } catch (error) {
        console.error('Klaviyo error, using mailto', error);
        this.mailtoSend();
      }
    } else {
      console.error('No klaviyo object, using mailto');
      this.mailtoSend();
    }
  }

  mailtoSend() {
    const mailtoLink = `mailto:${this.emailInput.value}?subject=${this.shareTitle}&body=${this.shareUrl}`;
    window.location.href = mailtoLink;
  }

  onError(error) {
    console.error(error);
  }
}

customElements.define('share-url-form', ShareUrlForm);

class ShareUrlModal extends ModalDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.shareForm = this.querySelector('share-url-form');
    this.modalTitle = this.querySelector('[data-share-title]');
  }

  populate(shareData) {
    if (this.modalTitle) {
      this.modalTitle.innerText = shareData.modalTitle || window.themeStrings.shareModal.title;
    }
    this.shareForm?.populate(shareData);
  }

  show(shareData) {
    this.populate(shareData);
    super.show();
  }
}

customElements.define('share-modal-dialog', ShareUrlModal);

class ShareUrlButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.modal = document.querySelector('share-modal-dialog');
    if (!this.modal || !this.button) return (this.hidden = true);
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const shareData = {
      url: this.getAttribute('share-url'),
      title: this.getAttribute('share-title'),
      image: this.getAttribute('share-image'),
      modalTitle: this.getAttribute('share-modal-title'),
      successMessage: this.getAttribute('success-message'),
      eventData: this.getAttribute('share-event-data'),
      eventName: this.getAttribute('share-event-name'),
    };
    this.modal.show(shareData);
  }
}

customElements.define('share-url-button', ShareUrlButton);

(() => {
  let footerPad = 0;
  document.querySelectorAll('[data-add-footer-padding="small"]').forEach((el) => {
    footerPad += el.clientHeight;
  });
  document.querySelector('.footer')?.style?.setProperty('--small-footer-pad-extra', `${footerPad}px`);
})();

(() => {
  const unstickClass = 'is-sticky-on-scroll';
  const unstickEl = document.querySelector('[data-unstick-on-scroll]');
  if (!unstickEl) return;
  const unstickTarget = document.querySelector(unstickEl.getAttribute('data-unstick-on-scroll'));
  let threshold;

  if ('IntersectionObserver' in window) {
    const unstickObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((unstickEl) => {
        if (unstickEl.isIntersecting) {
          threshold = document.scrollingElement.scrollTop;
          // unstickEl.target.classList.add(unstickClass);
          unstickTarget.classList.add(unstickClass);
          document.body.classList.add(unstickClass);
          // unstickObserver.unobserve(unstickEl.target);
        } else if (document.scrollingElement.scrollTop < threshold) {
          unstickTarget.classList.remove(unstickClass);
          document.body.classList.remove(unstickClass);
        }
      });
    });
    unstickObserver.observe(unstickEl);
  }
})();

(() => {
  /**
   * Format money values based on your shop currency settings
   *
   * This is a custom implementation of Shopify's formatMoney function which
   * strips off decimals if the price doesn't need to display cents.
   *
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @param  {Boolean} shop - use shop currency format if true
   * @return {String} value - formatted value
   */

  function formatMoney(cents, format, shop) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || window.shopSettings?.moneyFormat || '${{amount}}';

    if (shop == true) {
      formatString = window.shopSettings?.shopCurrencyFormat;
    }

    function formatWithDelimiters(number) {
      var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
      var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision); // if number doesn't have cents portion, strip this off

      number = number % 1 === 0 ? Number(number).toFixed(0) : number;
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  window.Shopify.theme.helpers.formatMoney = formatMoney;

  function getMobileQuickAddMarkup(data, cardContext, html2) {
    let html;
    if (!html2) {
      html = (strings, ...values) => String.raw({ raw: strings }, ...values);
    } else {
      html = html2;
    }
    const randomId = Math.round(Math.random() * 1000000); // used to ID modal & opener
    let mobileQuickAddMarkup = '';
    if (cardContext === 'wishlist') {
      mobileQuickAddMarkup = html`
        <div class="medium-hide large-up-hide quick-add quick-add--size-menu no-js-hidden">
          <variant-select-menu data-mobile class="display-contents">
            <modal-opener data-modal="#MobileQuickAdd-${randomId}">
              <button
                type="button"
                name="add"
                class="button button--secondary button--menu-opener button--full-width"
                aria-haspopup="dialog"
              >
                <span data-selected-label>${
                  data.variant ? data.variant.title : window.variantStrings.chooseSizeShort
                }</span>
                <svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10" viewBox="0 0 8 10" fill="none">
                  <g><path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path></g>
                </svg>
              </button>
            </modal-opener>
            <quick-buy data-via="${cardContext}" class="display-contents" variant-ids="${data.variant?.id}">
              <button
                type="button"
                name="add"
                class="quick-add__submit button button--full-width"
                aria-haspopup="dialog"
                data-product-url="${data.productLink}"
                ${data.variant?.available ? `` : `disabled`}
              >
                <span data-button-label>${
                  data.variant?.available ? window.variantStrings.addToCart : window.variantStrings.unavailable
                }</span>
                <div class="loading-overlay__spinner hidden">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </quick-buy>
            <modal-dialog
              id="MobileQuickAdd-${randomId}"
              class="global-modal global-modal--pop-up"
              data-dont-move-me
            >
              <div
                role="dialog"
                aria-label=""
                aria-modal="true"
                class="global-modal__content scrollbar"
                tabindex="-1"
              >
                <button
                  id="ModalClose-MobileQuickAdd-${randomId}"
                  type="button"
                  class="global-modal__toggle global-close-button"
                  aria-label="${window.accessibilityStrings.close}"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close">
                    <use href="#icon-close">
                  </svg>
                </button>
                <div class="global-modal__content-info">
                  <ul class="list-unstyled">
                    ${data.sizeVariants
          .map(
            (variant) =>
              html`
                            <li>
                              <button
                                data-variant-select="${variant.title}"
                                data-variant-id="${variant.id}"
                                class="button-popup-option${variant.available ? `` : ` disabled`}"
                                type="button"
                              >
                                ${variant.title}
                                <div class="loading-overlay__spinner hidden">
                                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                  </svg>
                                </div>
                              </button>
                            </li>
                          `
          )
          .join('')}
                  </ul>
                </div>
              </div>
            </modal-dialog>
          </variant-select-menu>
        </div>
      `;
    } else {
      if (!data.sizeVariants?.length) {
        mobileQuickAddMarkup = '';
      } else if (data.sizeVariants.length === 1) {
        mobileQuickAddMarkup = html`
          <div class="quick-add__mobile no-js-hidden">
            <quick-buy variant-ids="${data.sizeVariants[0].id}">
              <button
                type="button"
                class="button button--secondary button--full-width button--small button--quiet"
                ${data.sizeVariants[0].available ? `` : `disabled`}
              >
                ${data.sizeVariants[0].available ? window.variantStrings.quickBuy : window.variantStrings.soldOut}
                <!-- <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg> -->
              </button>
            </quick-buy>
          </div>
        `;
      } else {
        mobileQuickAddMarkup = html`
          <div class="quick-add__mobile no-js-hidden">
            <modal-opener data-modal="#MobileQuickAdd-${randomId}">
              <button
                type="button"
                class="button button--secondary button--full-width button--small button--quiet"
                aria-haspopup="dialog"
                data-product-url="${data.productLink}"
              >
                ${window.variantStrings.quickBuy}
                <div class="loading-overlay__spinner hidden">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </modal-opener>
            <modal-dialog
              id="MobileQuickAdd-${randomId}"
              class="global-modal global-modal--pop-up global-modal--no-pad global-modal--bg-strong"
            >
              <div role="dialog" aria-label="" aria-modal="true" class="global-modal__content scrollbar" tabindex="-1">
                <div class="global-modal__content-info">
                  <div class="quick-add__popup">
                    <div class="quick-add__popup-details">
                      <div class="card-information-top">
                        <h4 class="h6">
                          <a href="${data.productLink}" class="full-unstyled-link">
                            ${data.titleLine1} <span class="visually-hidden">${data.titleLine2}</span>
                          </a>
                        </h4>
                        <div class="flex-row space">
                          <p class="quick-add__popup-subheading">${data.titleLine2}</p>
                          <div
                            class="price${data.isOnSale ? ' price--on-sale' : ''}${data.isSoldOut
            ? ' price--sold-out'
            : ''}"
                          >
                            <div class="price__container">
                              <div class="price__regular">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--regular">${data.moneyPrice}</span>
                              </div>
                              <div class="price__sale">
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span>
                                  <s class="price-item price-item--regular">${data.moneyCompareAtPrice}</s>
                                </span>
                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                <span class="price-item price-item--sale price-item--last">${data.moneyPrice}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="quick-add__popup-variants">
                      <ul class="list-unstyled">
                        ${data.sizeVariants.map((variant) => {
              return html`
                            <li>
                              <quick-buy variant-ids="${variant.id}" data-via="${cardContext}">
                                ${variant.available ? html`
                                <button
                                  class="button-popup-option button-popup-option--hor"
                                  type="button"
                                >
                                  ${variant.title}
                                  <div class="loading-overlay__spinner hidden">
                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                  </div>
                                </button>
                                ` : html`
                                <button
                                  class="button-popup-option button-popup-option--hor"
                                  type="button"
                                  disabled
                                >
                                  ${variant.title}
                                  <div class="loading-overlay__spinner hidden">
                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                  </div>
                                </button>
                                `}
                              </quick-buy>
                            </li>
                          `;
            })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </modal-dialog>
          </div>
        `;
      }
    }
    return mobileQuickAddMarkup;
  }

  window.Shopify.theme.helpers.getMobileQuickAddMarkup = getMobileQuickAddMarkup;

  function getProductCardMarkup(
    product,
    variant,
    cardContext = '',
    objectType = 'shopify',
    enableMobileQuickAdd = true,
    
  ) {
    
    const randomId = Math.round(Math.random() * 1000000); // used to ID modal & opener
    const data = {
      productId: product.id,
      sizeVariants: product.variants?.filter((x) => x.option1 !== null),
      productTitle: product.title,
      compareAtPrice: product.compare_at_price_max,
      imageAspectRatio: window.themeSettings.cardImageRatio,
      imageSizesAttr: '(min-width: 990px) 25vw, calc((100vw - 48px) / 2)',
      imageWidthAttr: 1365,
      imageHeightAttr: 2048,
      imageLoadingAttr: 'lazy',
    };

// Clean product title
const cleanTitle = product.title.replaceAll('"', '').replaceAll("'", '');

// Clean variant names
const cleanVariants = product.variants.map(variant => ({
  ...variant,
  title: variant.title.replaceAll('"', '').replaceAll("'", ''),
  name: variant.name?.replaceAll('"', '').replaceAll("'", '')
}));

const productData = {
  id: product.id,
  handle: product.handle,
  title: cleanTitle,
  vendor: product.vendor,
  type: product.type,
  price: product.price,
  compare_at_price_max: product.compare_at_price_max,
  available: product.available,
  url: product.url,
  images: product.images,
  media: product.media,
  color_swatches: product.color_swatches,
  tags: product.tags,

  // Replace original variants with cleaned versions
  variants: cleanVariants,

  first_variant: {
    id: cleanVariants[0].id,
    sku: cleanVariants[0].sku,
    price: cleanVariants[0].price,
  }
};

    let productColor = product.title.split(" - ")[product.title.split(" - ").length - 1];
    productColor = productColor.replaceAll(' ', '-');
    productColor = productColor.replaceAll('--', '-');
    productColor = productColor.replaceAll('---', '-');
    productColor = productColor.replaceAll('/', '-');
    productColor = productColor.toLowerCase().trim();

    switch (objectType) {
      case 'shopify':
        data.variant = variant;
        data.price = product.price;
        data.productLink = product.url ?? `/products/${product.handle}`;
        data.secondaryImg =
          product.images && product.images.length > 1 ? product.images[product.images.length - 1] : null;
        data.currentColorValue = product.title.split(" - ")[product.title.split(" - ").length - 1];
        if(product.color_swatches){
          data.colorVariants = product.color_swatches;
        }
        break;
      case 'tagalys':
        data.price = product.price_min;
        data.productLink = product.__tagalys_fields.link;
        data.secondaryImg =
          product.images && product.images.length > 1 ? product.images[product.images.length - 1] : null;

        let colorVariants = product.__tagalys_fields?.stitched_products;
        if (colorVariants && colorVariants.length) {
          colorVariants = colorVariants.map((variant) => {
            const colorVal = variant.metafields.filter?.colour?.value[0];
            if (colorVal) {
              return {
                value: colorVal,
                link: variant.link,
                handle: colorVal.toLowerCase().trim(),
              };
            }
            return null;
          });
          colorVariants = colorVariants.filter((variant) => variant);
          colorVariants = colorVariants.length ? colorVariants : undefined;
        }
        data.colorVariants = colorVariants;
        break;
    }

    data.moneyPrice = formatMoney(data.price);
    data.moneyCompareAtPrice = formatMoney(data.compareAtPrice);
    data.titleLine1 = data.productTitle.split(' ')[0];
    data.titleLine2 = data.productTitle.split(' ').slice(1).join(' ');
    data.isSoldOut = !!product.available;
    data.isOnSale = !!(data.compareAtPrice > data.price);

    const badgeMarkup = getBadgeMarkup(product);

    let desktopQuickAddMarkup;

    if (cardContext === 'wishlist') {
      desktopQuickAddMarkup = html`
        <div class="small-hide quick-add quick-add--size-menu no-js-hidden">
          <variant-select-menu data-desktop class="display-contents">
            <modal-opener data-modal="#DesktopQuickAdd-${randomId}">
              <button
                type="button"
                name="add"
                class="button button--secondary button--menu-opener"
                aria-haspopup="dialog"
              >
                <span data-selected-label>${
                  data.variant ? data.variant.title : window.variantStrings.chooseSizeShort
                }</span>
                <svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10" viewBox="0 0 8 10" fill="none">
                  <g><path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path></g>
                </svg>
              </button>
            </modal-opener>
            <quick-buy data-via="${cardContext}" class="display-contents" variant-ids="${data.variant?.id}">
              <button
                type="button"
                name="add"
                class="quick-add__submit button button--full-width"
                aria-haspopup="dialog"
                data-product-url="${data.productLink}"
                ${data.variant.available ? `` : `disabled`}
              >
                <span data-button-label>${
                  data.variant.available ? window.variantStrings.addToCart : window.variantStrings.unavailable
                }</span>
                <div class="loading-overlay__spinner hidden">
                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                  </svg>
                </div>
              </button>
            </quick-buy>
            <modal-dialog
              id="DesktopQuickAdd-${randomId}"
              class="global-modal global-modal--pop-up global-modal--desktop-pop-up"
              data-dont-move-me
              data-allow-scrolling
            >
              <div
                role="dialog"
                aria-label=""
                aria-modal="true"
                class="global-modal__content scrollbar"
                tabindex="-1"
              >
                <button
                  id="ModalClose-DesktopQuickAdd-${randomId}"
                  type="button"
                  class="global-modal__toggle global-close-button"
                  aria-label="${window.accessibilityStrings.close}"
                >
                  <svg aria-hidden="true" focusable="false" class="icon icon-close">
                    <use href="#icon-close">
                  </svg>
                </button>
                <div class="global-modal__content-info">
                  <ul class="list-unstyled">
                    ${data.sizeVariants
          .map(
            (variant) =>
              html`
                            <li>
                              <button
                                data-variant-select="${variant.title}"
                                data-variant-id="${variant.id}"
                                class="button-popup-option${variant.available ? `` : ` disabled`}"
                                type="button"
                              >
                                ${variant.title}
                                <div class="loading-overlay__spinner hidden">
                                  <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                  </svg>
                                </div>
                              </button>
                            </li>
                          `
          )
          .join('')}
                  </ul>
                </div>
              </div>
            </modal-dialog>
          </variant-select-menu>
        </div>
      `;
    } else {
      desktopQuickAddMarkup = html`
        <div class="quick-add no-js-hidden">
          <ul class="quick-add__variants-atcs scrollbar">
            ${data.sizeVariants
          .map(
            (variant) =>
              `
                  <li>
                    <quick-buy variant-ids="${variant.id}" data-via="${cardContext}">
                      <button class="button-invisible" type="button" ${variant.available ? `` : `disabled`}>
                        ${variant.title}
                         <div class="loading-overlay__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" fill="none">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                      </button>
                    </quick-buy>
                  </li>
                `
          )
          .join('')}
          </ul>
        </div>
      `;
    }

    const mobileQuickAddMarkup = enableMobileQuickAdd ? getMobileQuickAddMarkup(data, cardContext) : ``;
    const renderedPriceHtml = renderPrice({
      price: data.price,
      compareAtPrice: data.compareAtPrice,
      moneyPrice: data.moneyPrice,
      moneyCompareAtPrice: data.compareAtPrice,
      formatMoney: formatMoney,
      available: product.available,
      quantityPriceBreaksConfigured: product.quantity_price_breaks_configured,
      priceVaries: product.price_varies,
      compareAtPriceVaries: product.compare_at_price_varies,
      includePercentage: true,
      showDiscountPercent: true,
      saleBadgeColorScheme: window.themeSettings.saleBadgeColorScheme || 'background-1',
      soldOutBadgeColorScheme: 'accent-2',
      showBadges: false,
      // ...and any other fields you need
    });    

    // prettier-ignore-start
    return html`
      <product-card
        context="${cardContext}"
        class="card-wrapper product-card-wrapper${enableMobileQuickAdd ? ` mobile-quick-add` : ``}"
        product-data='${JSON.stringify(productData)}'
      >
        <div
          class="card card--standard card--media card--compact-small"
          style="--ratio-percent:${(1 / data.imageAspectRatio) * 100}%;"
        >
          <div class="card__inner color-background-2 gradient ratio">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <card-media-carousel>
                  <ul class="card__media-carousel js-carousel-list">
                    ${product.media.slice(0, -1).map((currentMedia, index) => {
      let isVideo = false;
      let currentVideoSources = [];

      if (currentMedia.media_type === 'video') {
        isVideo = true;

        currentMedia.sources?.forEach((source) => {
          const existingFormatIndex = currentVideoSources.findIndex(
            (vidSource) => vidSource.format == source.format
          );
          if (existingFormatIndex === -1) {
            let videoType;
            switch (source.format.toLowerCase()) {
              case 'mp4':
                videoType = 'video/mp4';
                break;
              case 'webm':
                videoType = 'video/webm';
                break;
              case 'ogg':
                videoType = 'video/ogg';
                break;
              case 'm3u8':
                videoType = 'application/x-mpegURL';
                break;
              default:
            }
            currentVideoSources.push({
              format: source.format,
              url: source.url,
              type: videoType,
            });
          }
        });
      }

      return html`<li class="card__media-slide${index === 0 ? ' card__media-slide--active' : ''}">
                        ${isVideo
          ? html`<video
                              width="1365"
                              height="2048"
                              class="media__tag"
                              playsinline="playsinline"
                              autoplay="autoplay"
                              muted="muted"
                              loop="loop"
                            >
                              ${currentVideoSources.map(
            (vidSource) => html`<source
                                  data-src="${vidSource.url}"
                                  type="${vidSource.type}"
                                  src="${vidSource.url}">
                                </source>`
          )}
                              Sorry, your browser doesn't support embedded videos.
                            </video>`
          : html`<img
                              srcset="
                                ${currentMedia.src}&width=165   165w,
                                ${currentMedia.src}&width=360   360w,
                                ${currentMedia.src}&width=533   533w,
                                ${currentMedia.src}&width=720   720w,
                                ${currentMedia.src}&width=940   940w,
                                ${currentMedia.src}&width=1066 1066w
                              "
                              src="${currentMedia.src}"
                              sizes="${data.imageSizesAttr}"
                              alt="${product.title}"
                              class="motion-reduce media__tag"
                              loading="lazy"
                              width="1365"
                              height="2048"
                            />`}
                        ${index === 0 &&
        html`<img
                          srcset="
                            ${data.secondaryImg}&width=165   165w,
                            ${data.secondaryImg}&width=360   360w,
                            ${data.secondaryImg}&width=533   533w,
                            ${data.secondaryImg}&width=720   720w,
                            ${data.secondaryImg}&width=940   940w,
                            ${data.secondaryImg}&width=1066 1066w
                          "
                          src="${data.secondaryImg}"
                          sizes="${data.imageSizesAttr}"
                          alt="${product.title}"
                          class="card__media-ghost-image motion-reduce media__tag"
                          loading="lazy"
                          width="1365"
                          height="2048"
                        />`}
                      </li>`;
    })}
                  </ul>
                </card-media-carousel>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <div class="card-information-top">
                  <p class="h4 card__heading">
                    <a href="${data.productLink}"
                      >${data.titleLine1} <span class="visually-hidden">${data.titleLine2}</span></a
                    >
                  </p>
                  <div class="card_under-heading">
                    <p class="card__subheading">${data.titleLine2}</p>
                  </div>
                </div>
              </div>
              <div class="card__badge top left">${badgeMarkup}</div>
            </div>
          </div>
          ${product.media.length > 1 &&
      html`
            <div
              class="card__carousel-buttons"
              style="--ratio-percent: ${(1 / window.themeSettings.cardImageRatio) * 100}%;"
            >
              <button class="card__carousel-button js-carousel-prev">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  aria-hidden="true"
                  focusable="false"
                  class="icon icon-arrow"
                  viewBox="0 0 17 18"
                >
                  <g fill="none" fill-rule="evenodd" stroke="currentColor"><path d="m8 16 8-8-8-8M16 8H0" /></g>
                </svg>
              </button>
              <button class="card__carousel-button js-carousel-next">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  aria-hidden="true"
                  focusable="false"
                  class="icon icon-arrow"
                  viewBox="0 0 17 18"
                >
                  <g fill="none" fill-rule="evenodd" stroke="currentColor"><path d="m8 16 8-8-8-8M16 8H0" /></g>
                </svg>
              </button>
            </div>
          `}
          <div class="card__content">
            ${desktopQuickAddMarkup ? desktopQuickAddMarkup : ``}
            <div class="card__information">
              <div class="card-information-top">
              ${data.colorVariants
                ? `
                  <div class="card__swatches-mobile">
                    <ul class="list-unstyled flex-row">
                      ${/* Current product colour first */''}
                      ${data.colorVariants
                        .filter(c => c.handle === productColor)
                        .map(color => {
                          return `
                            <li>
                              <a 
                                href="${color.link}" 
                                class="color-swatch swatch-color-${color.handle}" >
                                <span class="visually-hidden">${color.value}</span>
                              </a>
                            </li>
                          `;
                        })
                        .join('')}
                      
                      ${/* Then render all other colours */''}
                      ${data.colorVariants
                        .filter(c => c.handle !== productColor)
                        .map(color => {
                          return `
                            <li>
                              <a 
                                href="${color.link}" 
                                class="color-swatch swatch-color-${color.handle}"
                              >
                                <span class="visually-hidden">${color.value}</span>
                              </a>
                            </li>
                          `;
                        })
                        .join('')}
                    </ul>
                  </div>
                `
        : `<div class="card__swatches-mobile" hidden></div>`}
                <h4 class="card__heading h6">
                  <a href="${data.productLink}" class="full-unstyled-link"
                    >${data.titleLine1} <span class="visually-hidden">${data.titleLine2}</span></a
                  >
                </h4>
                <div class="card_under-heading">
                  <p class="card__subheading">${data.titleLine2}</p>
                  ${data.colorVariants
        ? `
                        <div class="card__swatches">
                          <ul class="color-swatches">
                            ${data.colorVariants
          ?.map((color) => {
            return `
                                <li>
                                  <a href="${color.link}" class="color-swatch swatch-color-${color.handle} ${color.value == data.currentColorValue ? "is-active" : ""}" data-swatch-link>
                                    <span class="visually-hidden">${color.value}</span>
                                  </a>
                                </li>
                              `;
          })
          .join('')}
                          </ul>
                        </div>
                      `
         : `<div class="card__swatches" hidden></div>`}
                </div>
              </div>
              <div class="card-information">
                <span class="caption-large light"></span>
                ${renderedPriceHtml}
              </div>
            </div>
            <div class="card__badge top left">${badgeMarkup}</div>
            ${mobileQuickAddMarkup}
          </div>
        </div>
      </product-card>
    `;
    // prettier-ignore-end
  }

  window.Shopify.theme.helpers.getProductCardMarkup = getProductCardMarkup;

  function renderPrice(data) {
    // Helper: format money (you can override with your own implementation)
    const formatMoney = data.formatMoney || (v => v);
  
    // Root classes
    const classes = ['price'];
    if (data.priceClass) classes.push(data.priceClass);
    if (!data.available) classes.push('price--sold-out');
    if (data.compareAtPrice > data.price && !data.quantityPriceBreaksConfigured) {
      classes.push('price--on-sale');
    }
    if (data.compareAtPrice > data.price && data.quantityPriceBreaksConfigured) {
      classes.push('volume-pricing--sale-badge');
    }
    if (!data.priceVaries && data.compareAtPriceVaries) {
      classes.push('price--no-compare');
    }
    if (data.showBadges) classes.push('price--show-badge');
    const priceClassString = classes.join(' ');
  
    const isOnSale = data.compareAtPrice && data.compareAtPrice > data.price;
  
    // ----- Discount message 2 -----
    const discountMessage2 =
      data.discountMessage2Enable &&
      data.tags?.includes(data.discountMessage2Tag)
        ? (() => {
            const discountValue = (100 - data.discountMessage2Value) * 0.01;
            const discountPrice = formatMoney(data.price * discountValue);
            const hasDiscountToken = data.discountMessage2Content.includes('[discount]');
            const content = data.discountMessage2Content.replace('[discount]', discountPrice);
  
            return `
              <span class="discount_messaging${hasDiscountToken ? ' active' : ''}"
                    style="font-size:${data.discountMessage2FontSize}px;color:${data.discountMessage2Color};background-color:${data.discountMessage2Background}">
                ${content}
              </span>`;
          })()
        : '';
  
    // ----- Unit price -----
    const unitPrice =
      data.unitPrice && data.unitPriceMeasurement
        ? `
          <small class="unit-price caption${data.unitPriceMeasurement ? '' : ' hidden'}">
            <span class="visually-hidden">Unit price</span>
            <span class="price-item price-item--last">
              <span>${formatMoney(data.unitPrice)}</span>
              <span aria-hidden="true">/</span>
              <span class="visually-hidden">&nbsp;per&nbsp;</span>
              <span>
                ${
                  data.unitPriceMeasurement.referenceValue !== 1
                    ? data.unitPriceMeasurement.referenceValue
                    : ''
                }
                ${data.unitPriceMeasurement.referenceUnit}
              </span>
            </span>
          </small>`
        : '';
  
    // ----- Regular price span (basic) -----
    const regularPriceSpan = `
      <span class="visually-hidden visually-hidden--inline">Regular price</span>
      <span class="price-item price-item--regular">
        ${data.price === 0 ? (data.freeProductLabel || 'Free product') : formatMoney(data.price)}
      </span>
    `;
  
    // ----- Volume pricing regular block -----
    const regularBlockWithVolume = `
      <div class="price__regular">
        ${
          data.showCompareAtPrice &&
          !( !data.priceVaries && data.compareAtPriceVaries )
            ? `
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span>
                <s class="price-item price-item--regular variant-item__old-price">
                  ${formatMoney(data.compareAtPrice)}
                </s>
              </span>
            `
            : ''
        }
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular">
          ${
            // You can pre-compute this string on the backend if you want to keep translations
            data.volumePricingPriceRangeText ||
            `${formatMoney(data.moneyPriceMin)} – ${formatMoney(data.moneyPriceMax)}`
          }
        </span>
      </div>
    `;
  
    // ----- Simple regular block -----
    const regularBlockSimple = `
      <div class="price__regular">
        ${regularPriceSpan}
      </div>
    `;
  
    const regularBlock = data.quantityPriceBreaksConfigured
      ? regularBlockWithVolume
      : regularBlockSimple;
  
    // ----- Sale block -----
    const saleBlock = isOnSale
      ? (() => {
          const includePercentage = data.includePercentage === true;
          const percentOff =
            data.showDiscountPercent && data.compareAtPrice
              ? Math.round(((data.compareAtPrice - data.price) * 100) / data.compareAtPrice)
              : null;
  
          const showTopCompareAt =
            includePercentage && !(!data.priceVaries && data.compareAtPriceVaries);
  
          const topCompareAt = showTopCompareAt
            ? `
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span>
                <s class="price-item price-item--regular">
                  ${formatMoney(data.compareAtPrice)}
                </s>
              </span>`
            : '';
  
          const bottomCompareAt =
            data.includePercentage == null &&
            !(!data.priceVaries && data.compareAtPriceVaries && includePercentage)
              ? `
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span>
                  <s class="price-item price-item--regular">
                    ${formatMoney(data.compareAtPrice)}
                  </s>
                </span>`
              : '';
  
          const badge =
            includePercentage
              ? `
                <span
                  id="NoMediaStandardBadge-${data.sectionId}-${data.productId}"
                  class="badge badge--bottom-left color-${data.customColor || data.saleBadgeColorScheme}"
                >
                  ${
                    data.showDiscountPercent && percentOff !== null
                      ? (data.onSalePercentText || `-${percentOff}% off`)
                      : (data.onSaleText || 'On sale')
                  }
                </span>`
              : '';
  
          return `
            ${topCompareAt}
            <div class="price__sale">
              ${badge}
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last">
                ${formatMoney(data.price)}
              </span>
              ${bottomCompareAt}
            </div>`;
        })()
      : '';
  
    // ----- Badges under price -----
    const badges =
      data.showBadges
        ? `
          <span class="badge price__badge-sale color-${data.badgeColorScheme || data.saleBadgeColorScheme}">
            ${data.onSaleText || 'On sale'}
          </span>
          <span class="badge price__badge-sold-out color-${data.badgeColorScheme || data.soldOutBadgeColorScheme}">
            ${data.soldOutText || 'Sold out'}
          </span>`
        : '';
  
    // ----- Final HTML -----
    return `
      <div class="${priceClassString}">
        <div class="price__container">
          ${discountMessage2}
          ${isOnSale ? saleBlock : regularBlock}
          ${unitPrice}
        </div>
        ${badges}
      </div>
    `;
  }

  function getBadgeString(product, variant, colorStr = 'background-1') {
    return getBadgeMarkup(product, variant, colorStr, true);
  }

  function getBadgeMarkup(product, variant, colorStr = 'background-1', strOnly) {
    if (!product.tags) return ``;

    const price = product.price;
    const compareAtPrice = product.compare_at_price;

    let badgeText = false;
    let isFinalSaleBadge = false;

    let siteBadge = '__badge_us:';
    switch (Shopify.shop) {
      case 'meshki-clothing.myshopify.com':
        siteBadge = '__badge_au:';
        break;
      case 'meshki-uk.myshopify.com':
        siteBadge = '__badge_uk:';
        break;
      case 'meshki-uk.myshopify.com':
        siteBadge = '__badge_uk:';
        break;
    }

    let hasCustomBadge = false;
    let customBadge = null;
    for (const tag of product.tags) {
      if (tag.includes('__badge:')) {
        hasCustomBadge = true;
        customBadge = tag.replace('__badge:', '').split('|')[0];
      }
      if (tag.includes(siteBadge)) {
        hasCustomBadge = true;
        customBadge = tag.replace(siteBadge, '').split('|')[0];
        break;
      }
    }

    if (hasCustomBadge) {
      badgeText = customBadge;

      if (badgeText.toLowerCase().trim() === 'final sale') {
        isFinalSaleBadge = true;
      }
    } else if (!product.available || (variant && !variant.available)) {
      badgeText = window.variantStrings.soldOut;
    } else if (compareAtPrice > price) {
      if (window.themeSettings.showDiscountPercent) {
        const percentOff = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
        badgeText = window.variantStrings.onSalePercent.replace('[percent]', percentOff);
      } else {
        badgeText = window.variantStrings.onSale;
      }
    }

    if (!badgeText) {
      return '';
    }

    if (strOnly) return badgeText;

    return html`
      <span class="badge badge--bottom-left color-${colorStr}${isFinalSaleBadge ? ' badge--final-sale' : ''}"
        >${badgeText}</span
      >
    `;
  }

  window.Shopify.theme.helpers.getBadgeString = getBadgeString;
  window.Shopify.theme.helpers.getBadgeMarkup = getBadgeMarkup;

  const getUrlSearchObj = (searchStr = window.location.search) => {
    return Object.fromEntries(new URLSearchParams(searchStr));
  };

  window.Shopify.theme.helpers.getUrlSearchObj = getUrlSearchObj;
})();

/* Global Generic Methods */

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// Gift with purchase auto add to cart functionality
document.addEventListener("DOMContentLoaded", function() {
  if(!window.theme.gwp.enable) return;
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const [url, config] = args;
    const response = await originalFetch(...args);

    const isCartEndpoint =
      typeof url === 'string' &&
      (url.includes('/cart/update.js') || url.includes('/cart/add.js'));
    const hasSkipHeader =
      config?.headers?.['X-Skip-Cart-Event'] ||
      config?.headers?.get?.('X-Skip-Cart-Event');

    if(hasSkipHeader) return response;

    if (isCartEndpoint) {
      response.clone().json().then(cartData => {
        //document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      });
    }

    return response;
  };
})

// Set up a listener for the custom cart update event
document.addEventListener('cart:updated', function(event) {
  const cartData = event.detail;

  if(!window.theme.gwp.enable) return;
  
  // Only add to cart if above threshold, calculate the threshold in different currencies
  if(cartData.items?.some(item => item.variant_id === window.theme.gwp.variant_id) && cartData.original_total_price < calculateThreshold(cartData)) {
    removeGWP(cartData);
  }

  if (cartData.items?.some(item => item.variant_id === window.theme.gwp.variant_id) && !(customer?.tags.includes("swell_vip_platinum") || customer?.tags.includes("swell_vip_gold"))) {
    removeGWP(cartData);
  }

  if(cartData.items?.some(item => item.variant_id === window.theme.gwp.variant_id) && !customer?.tags.includes("loyaltyconsent_yes")) {
    removeGWP(cartData);
  }

  if(!(customer?.tags.includes("swell_vip_platinum") || customer?.tags.includes("swell_vip_gold"))) return;
  if(!customer?.tags.includes("loyaltyconsent_yes")) return;
  if(customer?.tags.includes("GWP Received")) return;

  // Check if item is in cart already
  if(cartData.items?.some(item => item.variant_id === window.theme.gwp.variant_id)) return;

  if(cartData.original_total_price > calculateThreshold(cartData)) addGWP(cartData);

  console.log('Cart updated!', cartData);
});

function removeGWP(cartData) {
  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const gwp_line = cartData.items.findIndex(item => item.variant_id === window.theme.gwp.variant_id);
  cart.disableCheckout();
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Skip-Cart-Event': 'true'
    },
    body: JSON.stringify({
      line: gwp_line + 1,
      quantity: 0
    })
  })
  .then(res => res.json())
  .then(() => {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sectionsToRender = cart.getSectionsToRender();
      const sectionIds = sectionsToRender.map(section => section.id);
      const sectionsUrl = window.location.pathname;

      return fetch(`/?sections=${sectionIds.join(',')}&sections_url=${encodeURIComponent(sectionsUrl)}`);
    } else {
      return Promise.reject(new Error('Cart does not support sections rendering'));
    }
  })
  .then(res => res.json())
  .then(sectionHtmls => {
    if (cart?.renderContents) {
      cart.renderContents({ sections: sectionHtmls });
    }
    cart.enableCheckout();
  })
  .catch((e) => {
    console.error('Error updating cart:', e);
    cart.enableCheckout();
  });
}

function addGWP(cartData) {
  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  cart.disableCheckout();
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Skip-Cart-Event': 'true'
    },
    body: JSON.stringify({
      id: window.theme.gwp.variant_id,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(() => {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sectionsToRender = cart.getSectionsToRender();
      const sectionIds = sectionsToRender.map(section => section.id);
      const sectionsUrl = window.location.pathname;

      return fetch(`/?sections=${sectionIds.join(',')}&sections_url=${encodeURIComponent(sectionsUrl)}`);
    } else {
      return Promise.reject(new Error('Cart does not support sections rendering'));
    }
  })
  .then(res => res.json())
  .then(sectionHtmls => {
    if (cart?.renderContents) {
      cart.renderContents({ sections: sectionHtmls });
    }
    cart.enableCheckout();
  })
  .catch((e) => {
    console.error('Error updating cart:', e);
    cart.enableCheckout();
  });
}

function calculateThreshold(cart) {
  let threshold = window.theme.gwp.threshold * 100;

  // Don't need to fuck with exchange rates
  if(cart.currency === shopSettings.shopCurrency) return threshold;

  return threshold *= Shopify.currency.rate;
}

function makeRegionSelectorOptionsHTML(regionSelectorOptions, currentLocationName) {
  let regionSelectorOptionsHTML = "";
  regionSelectorOptions.forEach(function(option) {
    if(option.isDefaultRegion) {
      regionSelectorOptionsHTML += `<li class="disclosure__item" tabindex="-1"><a rel="nofollow" data-code="${option.regionCode}" href="${option.regionDomain}${ option.requestPath }" class="disclosure__link focus-inset ${ option.isCurrentRegion ? "disclosure__link--active" : "" }" ${ option.isCurrentRegion ? 'aria-current="true"' : "" }>${ option.isCurrentRegion ? '<svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10"><use href="#icon-caret"></svg>':""}${ option.regionName }</a></li>`;
    }
    else {
      regionSelectorOptionsHTML += `<li class="disclosure__item" tabindex="-1"><a rel="nofollow" href="${ option.regionDomain }${ option.requestPath }?region=${ option.locationCode }&from=${currentLocationName}&location=${ option.locationName }&currency=${ option.locationCurrency }&via-feature=region-switcher" class="disclosure__link focus-inset ${ option.isSelected ? "disclosure__link--active" : "" }" ${ option.isSelected ? 'aria-current="true"' : "" }>${option.isSelected?'<svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10"><use href="#icon-caret"></svg>':""}${ option.locationName }</a></li>`;
    }
  });

  return regionSelectorOptionsHTML;
}

const facets_container = document.querySelector('.facets-container');
const product_grid_container = document.querySelector('.collection-hero__title');

if(facets_container && product_grid_container) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      facets_container.classList.toggle('is-sticky', !entry.isIntersecting);
    },
    { threshold: [0] }
  );

  observer.observe(product_grid_container);
}

// Add header classes when search dropdown is activated
// Only needed when the search input is not a megamenu dropdown item
const expandedForm = document.querySelector(".ss__form--expanded");

if (expandedForm) {

  const EXPANDED_SELECTOR = ".ss__form--expanded";

  function isInsideExpanded(target) {
    return !!(target && target.closest(EXPANDED_SELECTOR));
  }

  function openMenu() {
    document.body.classList.add("is-header-menu-open");
  }

  function closeMenu() {
    document.body.classList.remove("is-header-menu-open");
  }

  // Keyboard focus: Tab into / out of the expanded form
  document.addEventListener("focusin", (event) => {
    if (isInsideExpanded(event.target)) {
      openMenu();
    } else {
      // Focus moved somewhere else (e.g. user tabbed away)
      closeMenu();
    }
  });

  // Mouse / pointer: click in or out
  document.addEventListener("click", (event) => {
    if (isInsideExpanded(event.target)) {
      // Click anywhere inside the expanded form (even on non-focusable elements)
      openMenu();
    } else {
      // Clicked outside the expanded form
      closeMenu();
    }
  });
}